
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("12t1c", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $culkJ = parcelRequire("culkJ");


var $3v0xY = parcelRequire("3v0xY");


var $cgtv4 = parcelRequire("cgtv4");

const $614604228efdb790$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.jira",
        defaultMessage: "Jira"
    }
});


const $e306a0f1948559b4$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $e306a0f1948559b4$export$b34e755010aed2b2 = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($e306a0f1948559b4$var$icon, (0, $614604228efdb790$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).JIRA_SOFTWARE,
        analyticsName: (0, $culkJ.Products).JIRA_SOFTWARE,
        ...options
    });
module.exports["useJira"] = $e306a0f1948559b4$export$b34e755010aed2b2;

});

parcelRegister("ikOWI", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $4IT4p = parcelRequire("4IT4p");




const $65ddfdee4001ff48$export$a5c3144306783a42 = /*#__PURE__*/ (0, $42omo.createContext)({
    impressedProducts: {
        JIRA_SOFTWARE: false,
        CONFLUENCE: false
    }
});



var $87q77 = parcelRequire("87q77");

/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $iXCQx = parcelRequire("iXCQx");


var $cgtv4 = parcelRequire("cgtv4");

const $8640c6d7c63a6659$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    invitedLozenge: {
        id: "cross-join-nudges.invited-app-shortcuts.invited-lozenge",
        defaultMessage: "Invited"
    },
    popupMainTextWithCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators",
        defaultMessage: "You're invited to join your team"
    },
    popupMainTextWithoutCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators",
        defaultMessage: "Don't lose access, accept invite now"
    },
    popupAcceptInviteButton: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button",
        defaultMessage: "Accept invite"
    },
    popupCollaboratorsTooltip: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip",
        defaultMessage: "{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}"
    },
    jira: {
        id: "cross-join-nudges.invited-app-shortcuts.jira",
        defaultMessage: "Jira"
    },
    confluence: {
        id: "cross-join-nudges.invited-app-shortcuts.confluence",
        defaultMessage: "Confluence"
    }
});



const $606c22c7c79fc55a$var$styles = {
    container: "_1e0c11p5 _yv0e5bpd _4cvr1h6o _1bsb1osq",
    lozengeContainer: "_1e0c1txw _1bahesu3 _4cvr1h6o _1ul9idpf"
};

const $606c22c7c79fc55a$export$f60dc2630a14000a = ({ label: label, apsKey: apsKey })=>{
    const { impressedProducts: impressedProducts } = (0, $42omo.useContext)((0, $65ddfdee4001ff48$export$a5c3144306783a42));
    const hasAlreadySeenThisInvitedAppShortcut = impressedProducts[apsKey];
    const [AnimatedLozengeComponent, setAnimatedLozengeComponent] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        // Keep SSR and initial hydration light by rendering static Lozenge first.
        if (hasAlreadySeenThisInvitedAppShortcut) return;
         // Load animation code only for users who can actually see the animated treatment.
        (parcelRequire("liA74")).then((module)=>{
            setAnimatedLozengeComponent(module.default);
        });
    }, [
        hasAlreadySeenThisInvitedAppShortcut
    ]);
    const LozengeComponent = !hasAlreadySeenThisInvitedAppShortcut && AnimatedLozengeComponent ? AnimatedLozengeComponent : (0, $5nBzc.default);
    const shouldRenderLozenge = hasAlreadySeenThisInvitedAppShortcut || AnimatedLozengeComponent !== null;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $606c22c7c79fc55a$var$styles.container
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: label
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $606c22c7c79fc55a$var$styles.lozengeContainer
                ]),
                children: shouldRenderLozenge ? /*#__PURE__*/ (0, $l998X.jsx)(LozengeComponent, {
                    appearance: "inprogress",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).invitedLozenge
                    })
                }) : null
            })
        ]
    });
};


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $2Pg7f = parcelRequire("2Pg7f");


var $2Nwuj = parcelRequire("2Nwuj");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");










/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");








const $92ff5a7416518b84$var$styles = {
    root: "_2rkofajl _11c8wadc _vchhusvi _p12f1mjv _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna"
}; /**
    * As truncate is deprecated, we need to use a custom tooltip component to ensure the tooltip can show the message in one line.
    */ 
const $92ff5a7416518b84$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            $92ff5a7416518b84$var$styles.root,
            className
        ]),
        ref: ref,
        testId: "invited-app-collaborators-tooltip",
        children: children
    });
});
const $92ff5a7416518b84$export$cb6b49c74b6579bc = ({ children: children, currentApsKey: currentApsKey, currentAppCollaborators: currentAppCollaborators })=>{
    const { fireViewedMoreCollaboratorsTooltip: fireViewedMoreCollaboratorsTooltip } = (0, $87q77.useInvitedAppAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const appMessage = (0, $42omo.useMemo)(()=>{
        switch(currentApsKey){
            case 'JIRA_SOFTWARE':
                return (0, $8640c6d7c63a6659$export$defe85febe8b728c).jira;
            case 'CONFLUENCE':
                return (0, $8640c6d7c63a6659$export$defe85febe8b728c).confluence;
        }
    }, [
        currentApsKey
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        position: "right",
        component: $92ff5a7416518b84$var$CustomTooltip,
        onShow: ()=>fireViewedMoreCollaboratorsTooltip({
                app: (0, $4IT4p.getAppKeyByApsKey)(currentApsKey),
                collaborators: currentAppCollaborators.length
            }),
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupCollaboratorsTooltip,
            values: {
                numberOfCollaborators: currentAppCollaborators.length - 1,
                app: formatMessage(appMessage)
            }
        }),
        children: children
    });
};



const $fecd8b65ebd85911$var$InvitedAppPopup = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5VPVf")).then((module)=>({
            default: module.InvitedAppPopup
        })));
const $fecd8b65ebd85911$export$dcca2f78da63545d = ({ currentAppCollaborators: currentAppCollaborators, currentApsKey: currentApsKey, currentShortcutLink: currentShortcutLink, onMouseEnterPopup: onMouseEnterPopup, onMouseLeavePopup: onMouseLeavePopup, resolverResult: resolverResult, trigger: trigger })=>{
    const { fireLinkClickedAcceptInvite: fireLinkClickedAcceptInvite } = (0, $87q77.useInvitedAppAnalytics)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($fecd8b65ebd85911$var$InvitedAppPopup, {
            trigger: trigger,
            onMouseEnterPopup: onMouseEnterPopup,
            onMouseLeavePopup: onMouseLeavePopup,
            currentApsKey: currentApsKey,
            currentAppCollaborators: currentAppCollaborators,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        grow: "fill",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            alignBlock: "start",
                            alignInline: "start",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    children: currentAppCollaborators.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupMainTextWithCollaborators
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupMainTextWithoutCollaborators
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: currentShortcutLink,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: ()=>{
                                        const app = (0, $4IT4p.getAppKeyByApsKey)(currentApsKey);
                                        fireLinkClickedAcceptInvite({
                                            app: app
                                        });
                                        resolverResult?.registerActivation(app);
                                    },
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupAcceptInviteButton
                                    })
                                })
                            ]
                        })
                    }),
                    currentAppCollaborators.length > 0 && currentApsKey && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        grow: "hug",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Pg7f.default), {
                            data: currentAppCollaborators.map((collaborator)=>({
                                    ...collaborator,
                                    appearance: 'circle',
                                    size: 'medium'
                                })),
                            maxCount: 2,
                            overrides: {
                                MoreIndicator: {
                                    render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $92ff5a7416518b84$export$cb6b49c74b6579bc), {
                                            currentApsKey: currentApsKey,
                                            currentAppCollaborators: currentAppCollaborators,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                ...props,
                                                isActive: false,
                                                onClick: ()=>{}
                                            })
                                        })
                                }
                            }
                        })
                    }, currentApsKey)
                ]
            })
        })
    });
};


class $eb94a7a15b9af3a3$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, _errorInfo) {
        this.props.fireInvitedAppShortcutsContainerRenderFailed({
            error: error.message,
            errorStack: error.stack,
            targetApps: Object.values(this.props.shortcutsConfig).map((shortcut)=>shortcut.analyticsName).filter(Boolean)
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback({
            referrableShortcuts: this.props.shortcutsConfig
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $eb94a7a15b9af3a3$var$InvitedAppShortcutsContainerInner = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = 300, excludeLastFromRefs: excludeLastFromRefs = 0, children: children })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts } = (0, $87q77.useInvitedAppAnalytics)(); // the popup shown state
    const [isPopupShown, setIsPopupShown] = (0, $42omo.useState)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null); // refs for the shortcut items
    const jiraShortcutRef = (0, $42omo.useRef)(null);
    const confluenceShortcutRef = (0, $42omo.useRef)(null); // Store unbind functions for cleanup
    const unbindFunctionsRef = (0, $42omo.useRef)(new Map()); // Ref for the current shortcut item
    // the current shortcut item is unset when the popup is hidden after a delay
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $42omo.useState)(); // map of the shortcut items to their refs
    const shortcutRefs = (0, $42omo.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), // Refs are stable, no dependencies needed
    []);
    const showPopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(true);
    }, [
        setIsPopupShown
    ]);
    const hidePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, [
        setIsPopupShown,
        setCurrentShortcutRef
    ]);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(()=>{
            hidePopup();
        }, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hoverDelayTimeMs,
        hidePopup
    ]); /**
                                                            * @param targetRef - the ref to the shortcut item
                                                            * @returns a handler for the mouse over event on the shortcut item
                                                            */ 
    const handleMouseOverWithRef = (0, $42omo.useCallback)((targetRef)=>()=>{
            // clear the close popup timer to avoid closing the popup
            // when moving the mouse from the popup to the shortcut item
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
        }, [
        clearClosePopupTimer,
        showPopup
    ]); /**
                                          * @param targetRef - the ref to the shortcut item
                                          * @returns a handler for the mouse leave event on the shortcut item
                                          */ 
    const handleMouseLeaveWithRef = (0, $42omo.useCallback)(()=>()=>{
            if (currentShortcutRef?.current) currentShortcutRef.current.style.backgroundColor = '';
            startClosePopupTimer();
        }, [
        currentShortcutRef,
        startClosePopupTimer
    ]); /**
                                                   * @param targetRef - the ref to the shortcut item
                                                   * @returns a callback ref for a shortcut item
                                                   */ 
    const createShortcutRef = (0, $42omo.useCallback)((targetRef)=>(node)=>{
            // Cleanup previous element if it exists
            const existingUnbind = unbindFunctionsRef.current.get(targetRef);
            if (existingUnbind) {
                existingUnbind();
                unbindFunctionsRef.current.delete(targetRef);
            } // Store the new element
            // oxlint-disable-next-line no-param-reassign
            targetRef.current = node; // Attach listeners to new element
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const mouseleaveListener = handleMouseLeaveWithRef();
                const blurListener = handleMouseLeaveWithRef(); // Use bind-event-listener to bind all events and get an unbind function
                const unbind = (0, $fFa3V.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: mouseleaveListener
                    },
                    {
                        type: 'blur',
                        listener: blurListener
                    }
                ]); // Store the unbind function for cleanup
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeaveWithRef
    ]);
    /**
   * Handles the popup shown event
   * @returns a handler for the popup shown event
   */ const handleOnMouseEnterPopup = (0, $42omo.useCallback)(()=>{
        // clear the close popup timer to avoid closing the popup too early
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) // reference the background color variable from the design system
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/4ff76dcfb3ce12b4344e5345be748ce472ac56e7/platform/packages/design-system/navigation-system/src/ui/menu-item/menu-item.tsx#lines-166
            parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        } // ensure the popup is shown when mouse leaves the shortcut item and over the popup
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]); /**
                                                              * Handles the popup closed event
                                                              * @returns a handler for the popup closed event
                                                              */ 
    const handleOnMouseLeavePopup = (0, $42omo.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    const referrableShortcuts = (0, $42omo.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            // only add ref to shortcuts that are within the refs limit
            // and if it is a link and the aps key is allowed
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && resolverResult.invitedApps?.[(0, $4IT4p.getAppKeyByApsKey)(shortcut.apsKey)]?.eligible) {
                const apsKey = shortcut.apsKey;
                const app = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
                const targetRef = shortcutRefs[apsKey];
                const originalOnClick = shortcut.onClick;
                acc[key] = {
                    ...shortcut,
                    onClick: (evt)=>{
                        resolverResult.registerActivation(app);
                        return originalOnClick?.(evt);
                    },
                    ref: targetRef ? createShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, $l998X.jsx)((0, $606c22c7c79fc55a$export$f60dc2630a14000a), {
                        apsKey: apsKey,
                        label: shortcut.label
                    })
                }; // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult,
        createShortcutRef,
        shortcutRefs,
        excludeLastFromRefs
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentUnbindFunctions = unbindFunctionsRef.current;
        const currentShortcutRefs = shortcutRefs;
        return ()=>{
            // Clean up all event listeners using the stored unbind functions
            Object.values(currentShortcutRefs).forEach((ref)=>{
                const unbind = currentUnbindFunctions.get(ref);
                if (unbind) {
                    unbind();
                    currentUnbindFunctions.delete(ref);
                }
            });
            clearClosePopupTimer();
        };
    }, [
        clearClosePopupTimer,
        shortcutRefs
    ]);
    const currentApsKey = (0, $42omo.useMemo)(()=>Object.keys(shortcutRefs).find((apsKey)=>currentShortcutRef?.current === shortcutRefs[apsKey]?.current), [
        shortcutRefs,
        currentShortcutRef
    ]);
    const currentAppKey = currentApsKey && (0, $4IT4p.getAppKeyByApsKey)(currentApsKey);
    const currentAppResolved = currentAppKey && resolverResult.invitedApps?.[currentAppKey];
    const currentAppCollaborators = (0, $42omo.useMemo)(()=>currentAppResolved?.collaborators?.map((collab)=>({
                name: '',
                src: collab?.avatar
            })) ?? [], [
        currentAppResolved?.collaborators
    ]);
    const currentShortcutLink = (0, $42omo.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // These are the app keys for which we'll be displaying our treatment
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $4IT4p.isAllowedApsKey)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $4IT4p.getAppKeyByApsKey)(shortcut.apsKey));
            return acc;
        }, []);
        resolverResult.registerImpression({
            products: invitedAppShortcutKeys
        }); // Fire an analytics event when the user views the invited app shortcuts
        if (invitedAppShortcutKeys.length > 0) fireViewedInvitedAppShortcuts(invitedAppShortcutKeys);
    }, [
        referrableShortcuts,
        resolverResult,
        fireViewedInvitedAppShortcuts
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $65ddfdee4001ff48$export$a5c3144306783a42).Provider, {
        value: (0, $42omo.useMemo)(()=>({
                impressedProducts: {
                    JIRA_SOFTWARE: $eb94a7a15b9af3a3$var$isAppImpressed(resolverResult.invitedApps?.jira),
                    CONFLUENCE: $eb94a7a15b9af3a3$var$isAppImpressed(resolverResult.invitedApps?.confluence)
                }
            }), [
            resolverResult.invitedApps
        ]),
        children: [
            children({
                referrableShortcuts: referrableShortcuts
            }),
            isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && /*#__PURE__*/ (0, $l998X.jsx)((0, $fecd8b65ebd85911$export$dcca2f78da63545d), {
                trigger: currentShortcutRef,
                onMouseEnterPopup: handleOnMouseEnterPopup,
                onMouseLeavePopup: handleOnMouseLeavePopup,
                currentApsKey: currentApsKey,
                currentAppCollaborators: currentAppCollaborators,
                currentShortcutLink: currentShortcutLink,
                resolverResult: resolverResult
            })
        ]
    });
};
const $eb94a7a15b9af3a3$export$a06354f64c80dd3d = (props)=>{
    const { fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed } = (0, $87q77.useInvitedAppAnalytics)();
    return /*#__PURE__*/ (0, $l998X.jsx)($eb94a7a15b9af3a3$var$ErrorBoundary, {
        fallback: props.children,
        shortcutsConfig: props.shortcutsConfig,
        fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed,
        children: /*#__PURE__*/ (0, $l998X.jsx)($eb94a7a15b9af3a3$var$InvitedAppShortcutsContainerInner, {
            ...props
        })
    });
};
const $eb94a7a15b9af3a3$var$isAppImpressed = (appDetails)=>!!appDetails?.firstImpressionAt;
module.exports["InvitedAppShortcutsContainer"] = $eb94a7a15b9af3a3$export$a06354f64c80dd3d;

});

parcelRegister("4IT4p", function(module, exports) {

var $1mG05 = parcelRequire("1mG05");

const $511e8e2f0dc221c0$export$f45e7800f1f61594 = (apsKey)=>{
    if (!apsKey) return false;
    return (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS).includes(apsKey);
};
const $511e8e2f0dc221c0$export$b8c071b2cc567f75 = (apsKey)=>{
    switch(apsKey){
        case 'JIRA_SOFTWARE':
            return 'jira';
        case 'CONFLUENCE':
            return 'confluence';
        default:
            // This should never happen, throw it just in case if we add a new APS key without adding a new app key
            throw new Error(`Invalid APS key: ${apsKey}`);
    }
};
module.exports["isAllowedApsKey"] = $511e8e2f0dc221c0$export$f45e7800f1f61594;
module.exports["getAppKeyByApsKey"] = $511e8e2f0dc221c0$export$b8c071b2cc567f75;

});

parcelRegister("87q77", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $c4TO3 = parcelRequire("c4TO3");

const $8e76a58f4a588ff2$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
const $8e76a58f4a588ff2$export$43a7f5e28cb0f314 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isViewedInvitedAppShortcutsFired = (0, $42omo.useRef)(false);
    return (0, $42omo.useMemo)(()=>({
            /**
			 * Fire an analytics event when the user views the invited app shortcuts.
			 */ fireViewedInvitedAppShortcuts: (apps)=>{
                if (isViewedInvitedAppShortcutsFired.current) return;
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcuts',
                    attributes: {
                        apps: apps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
                isViewedInvitedAppShortcutsFired.current = true;
            },
            fireViewedInvitedAppShortcutPopup: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcutPopup',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireLinkClickedAcceptInvite: ({ app: app })=>{
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'acceptInvite',
                    attributes: {
                        app: app
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireViewedMoreCollaboratorsTooltip: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'moreCollaboratorsTooltip',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            /**
			 * Fire an analytics event when eligibility for invited app shortcuts is checked.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and ineligibilityReason has not changed since the
			 * last time the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * @param ineligibilityReason - the reason the user is ineligible
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireInvitedAppShortcutsEligibilityChecked: async ({ ineligibilityReason: ineligibilityReason, userId: userId, cloudId: cloudId })=>{
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${ineligibilityReason}`;
                if (await $8e76a58f4a588ff2$var$hasAlreadyBeenFired($8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'checked',
                    actionSubject: 'eligibility',
                    attributes: {
                        flagKey: 'twcg-460-personalised-invite-notifications-m2',
                        ineligibilityReason: ineligibilityReason
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
                await $8e76a58f4a588ff2$var$markAsFired($8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey);
            },
            /**
			 * Fire an analytics event when the feature is exposed.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and isEnabled has not changed since the last time
			 * the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * When the event fires, the eligibility-checked storage key is also cleared so that
			 * eligibility is re-evaluated after the user enters the experiment.
			 *
			 * @param isEnabled - the experiment's isEnabled value
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireFeatureExposed: async ({ isEnabled: isEnabled, userId: userId, cloudId: cloudId })=>{
                // Include the current date (YYYY-MM-DD) so the event fires at most once per day
                const today = new Date().toISOString().split('T')[0];
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${String(isEnabled)}:${today}`;
                if (await $8e76a58f4a588ff2$var$hasAlreadyBeenFired($8e76a58f4a588ff2$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        featureKey: 'twcg-460-personalised-invite-notifications-m2',
                        cohort: isEnabled ? 'variant' : 'control'
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
                await $8e76a58f4a588ff2$var$markAsFired($8e76a58f4a588ff2$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey);
                // Clear the eligibility checked flag since the feature is now exposed,
                // so that the next eligibility check will fire.
                $8e76a58f4a588ff2$var$clearStorageKey($8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY);
            },
            fireFetchInvitedAppShortcutsTraitsSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireFetchInvitedAppShortcutsTraitsFailed: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        collaborators: collaborators
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireEligibilityUpdateSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireEligibilityUpdateFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireInvitedAppShortcutsContainerRenderFailed: ({ targetApps: targetApps, error: error, errorStack: errorStack })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'invitedAppShortcutsContainerRender',
                    attributes: {
                        targetApps: targetApps,
                        error: error,
                        errorStack: errorStack
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            }
        }), [
        createAnalyticsEvent
    ]);
};
// ── Cross-session analytics dedup helpers ──────────────────────────────────────
//
// These helpers store a hashed fingerprint in local storage so that analytics
// events are only fired once per unique combination of parameters — even across
// page reloads. Each event type has its own storage key so they can be checked
// and cleared independently.
const $8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY = 'invitedAppShortcuts.eligibilityChecked';
const $8e76a58f4a588ff2$var$FEATURE_EXPOSED_STORAGE_KEY = 'invitedAppShortcuts.featureExposed';
// In-memory cache of the latest hash written per analytics storage key.
// This preserves dedupe within the current page session even if localStorage fails.
const $8e76a58f4a588ff2$var$firedHashByStorageKey = new Map();
// Circuit breaker for browser storage writes.
// Once a storage write throws (e.g. quota exceeded), we stop touching localStorage
// and fall back to in-memory dedupe only to avoid repeated runtime errors.
let $8e76a58f4a588ff2$var$shouldUseLocalStorage = true;
/**
 * Produces a non-reversible hash of the given raw string so we never store
 * plain-text identifiers in local storage.
 *
 * Prefers SHA-256 via the Web Crypto API when available, otherwise falls back
 * to a synchronous FNV-1a 32-bit hash for environments where the Web Crypto API
 * is not supported.
 *
 * @param raw - the raw string to hash
 * @returns a hex-encoded hash string
 */ async function $8e76a58f4a588ff2$var$hashString(raw) {
    // Primary path: SHA-256 via the Web Crypto API.
    // crypto.subtle is available in all modern browsers but requires a secure context (HTTPS).
    // It may be unavailable in:
    //   - Non-HTTPS pages (e.g. http://localhost without a secure context flag)
    //   - SSR / Node environments where the Web Crypto API is not globally available
    //   - Very old browsers (pre-Chrome 37, pre-Firefox 34, pre-Safari 11)
    if (typeof crypto !== 'undefined' && crypto.subtle) try {
        const data = new TextEncoder().encode(raw);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch  {
    // Fall through to the fallback hash
    }
    // Fallback: FNV-1a 32-bit hash.
    // Not cryptographically secure, but sufficient to avoid storing plain-text
    // identifiers in local storage. This path is only reached when the Web Crypto
    // API is unavailable (see conditions above) or throws unexpectedly.
    let hash = 0x811c9dc5;
    for(let i = 0; i < raw.length; i++){
        hash ^= raw.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16);
}
/**
 * Checks whether an analytics event has already been fired for the given
 * parameters by comparing a hashed fingerprint stored under `storageKey`.
 *
 * @param storageKey - the local storage key to read from
 * @param raw - the raw string representing the current parameter combination
 * @returns `true` if the stored hash matches, meaning the event should be suppressed.
 *          Returns `false` on any storage error.
 */ async function $8e76a58f4a588ff2$var$hasAlreadyBeenFired(storageKey, raw) {
    try {
        const hashed = await $8e76a58f4a588ff2$var$hashString(raw);
        if ($8e76a58f4a588ff2$var$firedHashByStorageKey.get(storageKey) === hashed) return true;
        if (!$8e76a58f4a588ff2$var$shouldUseLocalStorage) return false;
        const stored = (0, $c4TO3.AtlBrowserStorageLocal).getItem(storageKey);
        return stored === hashed;
    } catch  {
        return false;
    }
}
/**
 * Persists a hashed fingerprint so that future calls to {@link hasAlreadyBeenFired}
 * with the same `storageKey` and `raw` value will return `true`.
 *
 * Storage errors (e.g. private browsing, quota exceeded) are silently ignored.
 *
 * @param storageKey - the local storage key to write to
 * @param raw - the raw string representing the current parameter combination
 */ async function $8e76a58f4a588ff2$var$markAsFired(storageKey, raw) {
    try {
        const hashed = await $8e76a58f4a588ff2$var$hashString(raw);
        // Always keep an in-memory copy so we can still dedupe within a page session
        // even when browser storage is unavailable or full.
        $8e76a58f4a588ff2$var$firedHashByStorageKey.set(storageKey, hashed);
        if (!$8e76a58f4a588ff2$var$shouldUseLocalStorage) return;
        await (0, $c4TO3.AtlBrowserStorageLocal).setItem(storageKey, hashed);
    } catch  {
        // Storage quota/state can change at runtime (e.g. low storage, private mode).
        // Disable future localStorage writes to avoid repeated runtime errors.
        $8e76a58f4a588ff2$var$shouldUseLocalStorage = false;
    // Silently ignore storage errors (e.g. private browsing, quota exceeded)
    }
}
/**
 * Removes the stored fingerprint for the given storage key, allowing the
 * corresponding event to fire again regardless of previous parameters.
 *
 * @param storageKey - the local storage key to clear
 */ function $8e76a58f4a588ff2$var$clearStorageKey(storageKey) {
    try {
        $8e76a58f4a588ff2$var$firedHashByStorageKey.delete(storageKey);
        if (!$8e76a58f4a588ff2$var$shouldUseLocalStorage) return;
        (0, $c4TO3.AtlBrowserStorageLocal).removeItem(storageKey);
    } catch  {
    // Silently ignore storage errors
    }
}
module.exports["useInvitedAppAnalytics"] = $8e76a58f4a588ff2$export$43a7f5e28cb0f314;

});

parcelRegister("liA74", function(module, exports) {

let $f8174ab74cf3546c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8174ab74cf3546c$var$load("2ZKtw").then(()=>parcelRequire('lQJH8'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("5VPVf", function(module, exports) {

let $451a8d578cef5d20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $451a8d578cef5d20$var$load("dFhUX").then(()=>parcelRequire('lxQkl'));

});

parcelRegister("8dN99", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $8tdj3 = parcelRequire("8tdj3");


var $lAFHW = parcelRequire("lAFHW");


var $9x2sR = parcelRequire("9x2sR");


var $9wGTI = parcelRequire("9wGTI");


var $8sVSz = parcelRequire("8sVSz");

const $e47020b4a0088e3d$var$DEFAULT_COMPANY_HUB_NAME = 'Company Hub';
const $e47020b4a0088e3d$var$i18n = (0, $cgtv4.defineMessages)({
    CompanyHubName: {
        id: "side-navigation.custom.company-hub.shortcut-name",
        defaultMessage: "Company Hub"
    }
});
const $e47020b4a0088e3d$export$7d5e579a7612f1c2 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let isHidden;
    let onClick;
    let rest;
    if ($[0] !== t0) {
        ({ isHidden: isHidden, onClick: onClick, ...rest } = t0);
        $[0] = t0;
        $[1] = isHidden;
        $[2] = onClick;
        $[3] = rest;
    } else {
        isHidden = $[1];
        onClick = $[2];
        rest = $[3];
    }
    if (isHidden) return null;
    let t1;
    if ($[4] !== onClick || $[5] !== rest) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8sVSz.AbstractCompanyHubItem), {
            navVersion: "4"
        }, (t2)=>{
            const { companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick } = t2;
            const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
                size: "xsmall"
            });
            const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: "",
                spacing: "spacious",
                size: "small"
            });
            const onMenuLinkItemClick = ()=>{
                onClick?.();
                onAbstractCompanyHubItemClick();
            };
            const isDefaultCompanyHubName = companyHubName === $e47020b4a0088e3d$var$DEFAULT_COMPANY_HUB_NAME;
            if ((0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                const { peekingId: _peekingId, setPeekingId: _setPeekingId, draggableRef: draggableRef, ...dndProps } = rest;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                    ref: draggableRef,
                    elemAfter: elemAfter,
                    elemBefore: elemBefore,
                    href: namedRoute?.toUrl() || "#",
                    isSelected: isSelected,
                    onClick: onMenuLinkItemClick,
                    target: "_blank",
                    ...dndProps
                }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e47020b4a0088e3d$var$i18n.CompanyHubName) : companyHubName);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                elemAfter: elemAfter,
                elemBefore: elemBefore,
                href: namedRoute?.toUrl() || "#",
                isSelected: isSelected,
                onClick: onMenuLinkItemClick,
                target: "_blank"
            }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e47020b4a0088e3d$var$i18n.CompanyHubName) : companyHubName);
        });
        $[4] = onClick;
        $[5] = rest;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["CompanyHubItem"] = $e47020b4a0088e3d$export$7d5e579a7612f1c2;

});

parcelRegister("eI95o", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");


var $7CeAz = parcelRequire("7CeAz");


var $1ytiN = parcelRequire("1ytiN");


var $jyPfN = parcelRequire("jyPfN");

// TODO: there is a large useMenuItems.ts file that might need refactoring, but for the moment lets just duplicate the keys where they are needed
// to avoid coupling the new side navigation code with the old menu item code. We can look at unifying these in the future when we have more clarity on what the new side navigation needs to do.
const $b91cdc93c54e2058$var$SPACE_DIRECTORY_KEY = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $b91cdc93c54e2058$export$4873f44d198fe46c = ()=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            allowedWebItems: [
                $b91cdc93c54e2058$var$SPACE_DIRECTORY_KEY,
                $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY
            ]
        };
        $[0] = t0;
    } else t0 = $[0];
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)(t0);
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const { frontCoverState: frontCoverState, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    let t1;
    if ($[1] !== hasViewUserProfilePermission || $[2] !== webItems || $[3] !== webItemsLoading) {
        t1 = !webItemsLoading && (hasViewUserProfilePermission || !!webItems.find($b91cdc93c54e2058$var$_temp));
        $[1] = hasViewUserProfilePermission;
        $[2] = webItems;
        $[3] = webItemsLoading;
        $[4] = t1;
    } else t1 = $[4];
    const isPeopleVisible = t1;
    const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;
    let t2;
    if ($[5] !== isCompanyHubVisible || $[6] !== isPeopleVisible) {
        t2 = {
            isPeopleVisible: isPeopleVisible,
            isCompanyHubVisible: isCompanyHubVisible
        };
        $[5] = isCompanyHubVisible;
        $[6] = isPeopleVisible;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
function $b91cdc93c54e2058$var$_temp(item) {
    return item.completeKey === $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY;
}
module.exports["useShortcutVisibilityOverrides"] = $b91cdc93c54e2058$export$4873f44d198fe46c;

});

parcelRegister("1jJCz", function(module, exports) {

var $aQN68 = parcelRequire("aQN68");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");

const $fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts = (0, $aQN68.default);
const $fbb15aeb32df38cf$export$54d534cc91e54850 = ()=>{
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts);
    const { data: data } = queryResult;
    return (0, $42omo.useMemo)(()=>{
        const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
        return licensedProducts.reduce((acc, product)=>{
            if (product.licenseStatus !== 'ACTIVE') return acc;
            switch(product.productKey){
                case 'jira-software':
                    acc.hasJira = true;
                    break;
                case 'loom':
                    acc.hasLoom = true;
                    break;
                default:
                    break;
            }
            return acc;
        }, {
            hasJira: false,
            hasLoom: false
        });
    }, [
        data
    ]);
};
module.exports["useLicensedProducts"] = $fbb15aeb32df38cf$export$54d534cc91e54850;

});

parcelRegister("h7d8T", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $ay6Zz = parcelRequire("ay6Zz");


var $1NBp8 = parcelRequire("1NBp8");


var $bQm3c = parcelRequire("bQm3c");


var $5XsiK = parcelRequire("5XsiK");

const $3fcbe4d85cbec684$export$597036aedc68c98f = ()=>{
    const $ = (0, $frIzR.c)(8);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId || $[1] !== orgId) {
        t0 = (0, $ay6Zz.navigateToTeamsApp)({
            type: "LANDING",
            cloudId: cloudId,
            orgId: orgId,
            userHasNav4Enabled: true
        });
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t0;
    } else t0 = $[2];
    const { href: href } = t0;
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.COMPANY_HUB).toUrl();
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== href) {
        t2 = (0, $5XsiK.isTeamsAppEnabled)() ? href : "";
        $[4] = href;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            companyHubShortcut: t1,
            teamsShortcut: t2
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["useFallbackUrls"] = $3fcbe4d85cbec684$export$597036aedc68c98f;

});

parcelRegister("7DAwP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $culkJ = parcelRequire("culkJ");


var $3v0xY = parcelRequire("3v0xY");


var $cgtv4 = parcelRequire("cgtv4");

const $82db327e56ac3de4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.company-hub",
        defaultMessage: "Company Hub"
    }
});


const $5a42c6aaec7538b2$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.HubIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $5a42c6aaec7538b2$export$50e5fd99bfef1a4a = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($5a42c6aaec7538b2$var$icon, (0, $82db327e56ac3de4$export$defe85febe8b728c).label, fallbackUrl, {
        analyticsName: (0, $culkJ.Products).ATLAS_HUB,
        ...options
    });



var $12t1c = parcelRequire("12t1c");




parcelRequire("42omo");













const $e96a79584135f443$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.loom",
        defaultMessage: "Loom"
    }
});


const $4898362ef69c915e$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.LoomIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $4898362ef69c915e$export$ef6b4021b8157342 = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($4898362ef69c915e$var$icon, (0, $e96a79584135f443$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).LOOM,
        analyticsName: (0, $culkJ.Products).LOOM,
        ...options
    });



var $GEjfy = parcelRequire("GEjfy");


var $9wGTI = parcelRequire("9wGTI");


var $5XsiK = parcelRequire("5XsiK");


var $8dN99 = parcelRequire("8dN99");


var $eI95o = parcelRequire("eI95o");


var $h7d8T = parcelRequire("h7d8T");


var $1jJCz = parcelRequire("1jJCz");

const $f02b9571823f0450$export$ed2673425deb0c2f = (props)=>{
    const $ = (0, $frIzR.c)(21);
    const fallbackUrls = (0, $h7d8T.useFallbackUrls)();
    const { hasLoom: hasLoom, hasJira: hasJira } = (0, $1jJCz.useLicensedProducts)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $5XsiK.isTeamsAppEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const teamsAppEnabled = t0;
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $eI95o.useShortcutVisibilityOverrides)();
    const companyHubShortcutWithoutComponent = (0, $5a42c6aaec7538b2$export$50e5fd99bfef1a4a)(fallbackUrls.companyHubShortcut);
    const jiraShortcut = (0, $12t1c.useJira)("");
    const loomShortcut = (0, $4898362ef69c915e$export$ef6b4021b8157342)("");
    const teamsShortcut = (0, $GEjfy.useTeams)(fallbackUrls.teamsShortcut);
    props?.teamsShortcutConfig;
    let t1;
    if ($[1] !== companyHubShortcutWithoutComponent) {
        t1 = {
            ...companyHubShortcutWithoutComponent,
            menuItemId: "companyHubShortcut",
            type: "component",
            isReorderable: true,
            component: $f02b9571823f0450$var$_temp
        };
        $[1] = companyHubShortcutWithoutComponent;
        $[2] = t1;
    } else t1 = $[2];
    const companyHubShortcut = t1;
    let t2;
    if ($[3] !== companyHubShortcut || $[4] !== isCompanyHubVisible) {
        t2 = isCompanyHubVisible ? {
            companyHubShortcut: companyHubShortcut
        } : {};
        $[3] = companyHubShortcut;
        $[4] = isCompanyHubVisible;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== hasJira || $[7] !== jiraShortcut) {
        t3 = hasJira ? {
            jiraShortcut: jiraShortcut
        } : {};
        $[6] = hasJira;
        $[7] = jiraShortcut;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== hasLoom || $[10] !== loomShortcut) {
        t4 = hasLoom ? {
            loomShortcut: loomShortcut
        } : {};
        $[9] = hasLoom;
        $[10] = loomShortcut;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isPeopleVisible || $[13] !== props?.teamsShortcutConfig || $[14] !== teamsShortcut) {
        t5 = isPeopleVisible && teamsAppEnabled ? {
            teamsShortcut: props?.teamsShortcutConfig && (0, $9wGTI.fg)("teams-shortcut-next-confluence") ? props?.teamsShortcutConfig : teamsShortcut
        } : {};
        $[12] = isPeopleVisible;
        $[13] = props?.teamsShortcutConfig;
        $[14] = teamsShortcut;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
        t6 = {
            ...t2,
            ...t3,
            ...t4,
            ...t5
        };
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
};
function $f02b9571823f0450$var$_temp(itemProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dN99.CompanyHubItem), itemProps);
}
module.exports["useShortcutItemsConfig"] = $f02b9571823f0450$export$ed2673425deb0c2f;

});

parcelRegister("GEjfy", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $culkJ = parcelRequire("culkJ");


var $3v0xY = parcelRequire("3v0xY");


var $cgtv4 = parcelRequire("cgtv4");

const $6e45175315a8a66e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.teams",
        defaultMessage: "Teams"
    }
});


const $3dab1474f6c2c995$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $3dab1474f6c2c995$export$6fe02dcc2001dcb0 = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($3dab1474f6c2c995$var$icon, (0, $6e45175315a8a66e$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).ATLAS_TEAMS,
        analyticsName: (0, $culkJ.Products).ATLAS_TEAMS,
        ...options
    });
module.exports["useTeams"] = $3dab1474f6c2c995$export$6fe02dcc2001dcb0;

});

parcelRegister("fPgmM", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ajypD = parcelRequire("ajypD");

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

var $7L5zP = parcelRequire("7L5zP");

/**
 * This config setup allows us to debug/QA the experience by adjusting
 * some settings via localStorage overrides.
 *
 * Otherwise, we'd have to wait for days to observe cache expiry/refresh behavior,
 * and in-source-product minimum activity times.
 */ const $b7046f0a38984949$export$44487a86467333c3 = ()=>$b7046f0a38984949$var$CONSTANTS_AS_DEBUGGABLE_GETTERS;
const $b7046f0a38984949$var$timespan = ({ days: days = 0, minutes: minutes = 0, seconds: seconds = 0 })=>((days * 1440 + minutes) * 60 + seconds) * 1000;
const $b7046f0a38984949$var$CONSTANTS = {
    TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE: $b7046f0a38984949$var$timespan({
        days: 3
    }),
    /**
	 * When the customer visits after this time since we last wrote data to the cache,
	 * we'll refresh the cache: refetch the required data.
	 */ CACHE_TIME_UNTIL_REFRESH: $b7046f0a38984949$var$timespan({
        days: 7
    }),
    /**
	 * When the customer visits after this time since we last wrote data to the cache,
	 * we'll consider the cache expired and invalid, and not eligible to see the experiment
	 * (the user will not see the treatment on that visit).
	 * We will refresh the cache at that time, but even if that comes back as eligible,
	 * it will only affect future visits.
	 */ CACHE_TIME_UNTIL_EXPIRY: $b7046f0a38984949$var$timespan({
        days: 10
    })
};
const $b7046f0a38984949$var$CONSTANTS_AS_DEBUGGABLE_GETTERS = {
    get TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE () {
        return $b7046f0a38984949$var$getDebuggableTiming('TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE');
    },
    get CACHE_TIME_UNTIL_REFRESH () {
        return $b7046f0a38984949$var$getDebuggableTiming('CACHE_TIME_UNTIL_REFRESH');
    },
    get CACHE_TIME_UNTIL_EXPIRY () {
        return $b7046f0a38984949$var$getDebuggableTiming('CACHE_TIME_UNTIL_EXPIRY');
    }
};
function $b7046f0a38984949$var$getDebuggableTiming(key) {
    if (typeof localStorage !== 'undefined' && localStorage) {
        const debugLocalStorageKey = `invitedAppShortcutsDebug_${key}_seconds`;
        const overrideValue = parseInt(localStorage[debugLocalStorageKey], 10);
        if (typeof overrideValue === 'number' && overrideValue >= 0) return $b7046f0a38984949$var$timespan({
            seconds: overrideValue
        });
    }
    return $b7046f0a38984949$var$CONSTANTS[key];
}


const $3438e954aa0087f3$var$cacheKey = 'invitedAppShortcuts';
const $3438e954aa0087f3$var$localStorageCacheDebugKey = `${$3438e954aa0087f3$var$cacheKey}Debug`;
class $3438e954aa0087f3$export$7bddb475c47d45d {
    async write(state) {
        if ($3438e954aa0087f3$var$cacheDebugMode() === 'local-storage') {
            localStorage[$3438e954aa0087f3$var$cacheKey] = JSON.stringify(state);
            return true;
        }
        const result = await this.setCookie($3438e954aa0087f3$var$cacheKey, JSON.stringify(state), {
            expires: new Date(Date.now() + (0, $b7046f0a38984949$export$44487a86467333c3)().CACHE_TIME_UNTIL_EXPIRY),
            sameSite: 'strict'
        });
        return result === true || result === (0, $7L5zP.Status).SUCCESS;
    }
    read({ ssr: ssr }) {
        const throwOnError = ssr;
        if ($3438e954aa0087f3$var$cacheDebugMode() === 'local-storage') {
            if (localStorage?.[$3438e954aa0087f3$var$cacheKey]) return this.parseCachedState({
                rawValue: localStorage[$3438e954aa0087f3$var$cacheKey],
                throwOnError: throwOnError
            });
        } else {
            const cookieValueString = this.getCookie($3438e954aa0087f3$var$cacheKey, ssr);
            if (cookieValueString) return this.parseCachedState({
                rawValue: cookieValueString,
                throwOnError: throwOnError
            });
        }
        return null;
    }
    parseCachedState({ rawValue: rawValue, throwOnError: throwOnError }) {
        // Reuse parsed state for identical cookie/localStorage payloads during the same render lifecycle.
        if (this.lastParsedRawValue === rawValue) return this.lastParsedState;
        try {
            const decoded = $3438e954aa0087f3$var$isUrlEncodedJson(rawValue) ? decodeURIComponent(rawValue) : rawValue;
            const parsed = JSON.parse(decoded) || null;
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = parsed;
            return parsed;
        } catch (error) {
            if (throwOnError) throw error;
            // Subsequent client reads: swallow parse errors for robustness; treat as cache miss.
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = null;
            return null;
        }
    }
    constructor({ getCookie: getCookie = (0, $hEbxW.getCookie), setCookie: setCookie = (0, $eGd7K.setCookie) } = {}){
        this.getCookie = void 0;
        this.setCookie = void 0;
        this.lastParsedRawValue = null;
        this.lastParsedState = null;
        this.getCookie = getCookie;
        this.setCookie = setCookie;
    }
}
const $3438e954aa0087f3$var$isUrlEncodedJson = (json)=>json && (json.startsWith(`{%22`) || // `{"` with only `"` encoded -- this was value was observed in Confluence
    json.startsWith(`%7B%22`)); // `{"` encoded
const $3438e954aa0087f3$var$cacheDebugMode = ()=>{
    const debugMode = typeof localStorage !== 'undefined' && localStorage && // Extra safety while we're in the debug-only phase,
    // before we've switched to the proper browser controls (to be removed when that happens).
    // Requires manually setting localStorage.invitedAppShortcutsDebug = "true" in the console
    // to allow our code to write anything into the local storage cache.
    localStorage[$3438e954aa0087f3$var$localStorageCacheDebugKey];
    if (debugMode === 'cookie-delete') {
        localStorage[$3438e954aa0087f3$var$localStorageCacheDebugKey] = null;
        (0, $ajypD.deleteCookie)($3438e954aa0087f3$var$cacheKey);
    } else if (debugMode && ![
        'null',
        'false'
    ].includes(debugMode)) return 'local-storage';
    return null;
};





var $dh538 = parcelRequire("dh538");


var $1mG05 = parcelRequire("1mG05");


var $69QGC = parcelRequire("69QGC");

const $87431fe3ef192df3$export$c25eadb566c78ee = async (products, cloudId, accountIds)=>{
    const response = await fetch('/gateway/api/growth/invite-notify-1p/get-permitted-users-with-products', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            products: products,
            accountIds: accountIds
        })
    });
    return await response.json();
};


const $dd5e2face8bc024d$export$5391c0e0cb095e8a = async ({ cloudId: cloudId, products: products, userId: userId })=>{
    const collaborators = await (0, $69QGC.getUsersFromCollaborationGraph)('invitedAppShortcuts', cloudId, userId);
    if (collaborators.length === 0) return [];
    const collabsInProducts = await (0, $87431fe3ef192df3$export$c25eadb566c78ee)(products, cloudId, collaborators.map((c)=>c.id));
    return $dd5e2face8bc024d$var$mapToCollaboratorsWithProducts(collaborators, collabsInProducts);
};
const $dd5e2face8bc024d$var$mapToCollaboratorsWithProducts = (collaborators, usersWithProducts)=>collaborators.flatMap((collaborator)=>{
        const userWithProducts = usersWithProducts[collaborator.id];
        if (!(userWithProducts && userWithProducts.length > 0)) return [];
        return {
            collaborator: collaborator,
            products: userWithProducts
        };
    });



var $87q77 = parcelRequire("87q77");




const $74915a9b8039531c$export$12e73c04b5fd5da2 = new Set([
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS),
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)
]);
const $74915a9b8039531c$export$130cf0f0f2a54797 = {
    EXPERIMENT_OFF: 'EXPERIMENT_OFF',
    ERROR: 'ERROR',
    CACHE_EMPTY: 'CACHE_EMPTY',
    CACHE_EMPTY_USER_MISMATCH: 'CACHE_EMPTY_USER_MISMATCH',
    CACHE_EXPIRED: 'CACHE_EXPIRED',
    NO_TARGET_PRODUCTS: 'NO_TARGET_PRODUCTS',
    NO_ACCESS_TO_TARGET_PRODUCTS: 'NO_ACCESS_TO_TARGET_PRODUCTS',
    TARGET_PRODUCTS_NOT_VISIBLE: 'TARGET_PRODUCTS_NOT_VISIBLE',
    TARGET_PRODUCTS_ALL_ACTIVE: 'TARGET_PRODUCTS_ALL_ACTIVE',
    SOURCE_PRODUCT_TOO_NEW: 'SOURCE_PRODUCT_TOO_NEW'
};
const $74915a9b8039531c$export$fd93bc3ed8f14580 = 'updateId';
const $74915a9b8039531c$export$ebd0d23278a50416 = {
    NOT_CHECKED: undefined,
    INACTIVE: null
};



var $c6GJD = parcelRequire("c6GJD");

const $a834e0c1c192b1ad$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue, options = {})=>{
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, defaultValue, options);
    return experimentValue;
};






var $4IT4p = parcelRequire("4IT4p");


const $bc7598b146379920$var$queue = [];
const $bc7598b146379920$export$3f9c9dc8b61499e9 = (cache, updater)=>{
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    const processUpdate = async ()=>{
        const prev = cache.read({
            ssr: false
        }) ?? {};
        try {
            const result = updater(prev);
            if (result === null || result === prev) resolve(prev);
            else {
                await cache.write(result);
                resolve(result);
            }
        } catch (error) {
            reject(error);
        }
        $bc7598b146379920$var$queue.shift(); // Remove the processed update
        if ($bc7598b146379920$var$queue.length > 0) {
            const nextProcessUpdate = $bc7598b146379920$var$queue[0];
            nextProcessUpdate(); // Start the next update, keep it in the queue (blocking) until processed
        }
    };
    $bc7598b146379920$var$queue.push(processUpdate);
    if ($bc7598b146379920$var$queue.length === 1) processUpdate();
    return promise;
};



const $58987587447d73e1$export$2331136d2a146e0b = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cache: cache })=>{
    if (targetProducts.length === 0) return {
        eligibility: $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).NO_TARGET_PRODUCTS)
    };
    const cached = cache.read({
        ssr: true
    });
    if (userId && cached && cached.uid && userId !== cached.uid) {
        // Extra protection: clear cache asynchronously in the background, ignoring errors.
        // The hook will then fill the cache for the correct, current user.
        Promise.resolve().then(()=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, ()=>({
                    uid: cached.uid
                }))).catch(()=>{});
        return {
            eligibility: $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY_USER_MISMATCH)
        };
    }
    if (!(cached && cached.apps)) return {
        eligibility: $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY)
    };
    const resolvedDetails = $58987587447d73e1$export$6d313cb53294e81({
        sourceProduct: sourceProduct,
        targetProducts: targetProducts
    }, cached);
    return {
        eligibility: resolvedDetails,
        state: cached
    };
};
const $58987587447d73e1$export$6d313cb53294e81 = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, timestamp: timestamp = Date.now() }, cachedState)=>{
    if (targetProducts.length === 0) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).NO_TARGET_PRODUCTS);
    let invitedApps = {};
    let hasAccessToAtLeastOneTarget = null;
    let atLeastOneTargetVisible = null;
    let atLeastOneTargetInactive = false;
    for (const targetProduct of targetProducts){
        const cachedApp = cachedState.apps?.[targetProduct];
        if (!cachedApp) continue;
        if (cachedApp.access != null) hasAccessToAtLeastOneTarget = hasAccessToAtLeastOneTarget || cachedApp.access;
        if (cachedApp.visible != null) atLeastOneTargetVisible = atLeastOneTargetVisible || cachedApp.visible;
        if (cachedApp.access && cachedApp.visible && cachedApp.firstActive === (0, $74915a9b8039531c$export$ebd0d23278a50416).INACTIVE) {
            atLeastOneTargetInactive = true;
            invitedApps[targetProduct] = {
                eligible: true,
                collaborators: Array.from({
                    length: cachedApp.collaboratorCount ?? 0
                }).map((_, index)=>cachedApp.collaboratorDetails?.[index] ?? null),
                firstImpressionAt: cachedApp?.firstImpressionAt ?? null
            };
        }
    }
    if (hasAccessToAtLeastOneTarget === null || atLeastOneTargetVisible === null) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY);
    if (!hasAccessToAtLeastOneTarget) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).NO_ACCESS_TO_TARGET_PRODUCTS);
    if (!atLeastOneTargetVisible) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).TARGET_PRODUCTS_NOT_VISIBLE);
    if (!(cachedState.firstActiveUpdatedTimestamp && timestamp <= cachedState.firstActiveUpdatedTimestamp + (0, $b7046f0a38984949$export$44487a86467333c3)().CACHE_TIME_UNTIL_EXPIRY)) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EXPIRED);
    if (sourceProduct !== 'home') {
        const firstActiveInSourceProduct = cachedState.apps?.[sourceProduct]?.firstActive;
        if (!firstActiveInSourceProduct) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY);
        if (timestamp - firstActiveInSourceProduct < (0, $b7046f0a38984949$export$44487a86467333c3)().TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).SOURCE_PRODUCT_TOO_NEW);
    }
    if (!atLeastOneTargetInactive) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).TARGET_PRODUCTS_ALL_ACTIVE);
    return {
        ineligibilityReason: null,
        invitedApps: invitedApps
    };
};
const $58987587447d73e1$export$16cb62545527283a = (reason)=>({
        ineligibilityReason: reason
    });
const $58987587447d73e1$export$fe1089e917806f3c = (cachedState)=>!cachedState?.firstActiveUpdatedTimestamp || Date.now() > cachedState.firstActiveUpdatedTimestamp + (0, $b7046f0a38984949$export$44487a86467333c3)().CACHE_TIME_UNTIL_REFRESH;
const $58987587447d73e1$export$b97783bc9c26cb8b = async ({ access: accessMap, visibility: visibilityMap, traits: traits, userId: userId, cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            uid: userId,
            apps: {
                ...prev?.apps
            }
        };
        const traitsByName = $58987587447d73e1$var$groupTraitsByName(traits);
        for (const product of (0, $74915a9b8039531c$export$12e73c04b5fd5da2)){
            const appAccess = accessMap[product];
            const appVisibility = visibilityMap[product];
            const traitValue = $58987587447d73e1$var$getProductFirstActiveTraitValue(product, traitsByName);
            if (traitValue !== $58987587447d73e1$var$FIRST_ACTIVE_NOT_APPLICABLE) {
                const firstActive = traitValue ? $58987587447d73e1$export$bca6124add6e242(traitValue) : null;
                const draftApp = {
                    ...draft.apps[product]
                };
                if (firstActive) draftApp.firstActive = firstActive;
                else if (appAccess === true) draftApp.firstActive = (0, $74915a9b8039531c$export$ebd0d23278a50416).INACTIVE;
                if (appAccess !== undefined) draftApp.access = appAccess;
                if (appVisibility !== undefined) draftApp.visible = appVisibility;
                draft.apps[product] = draftApp;
            }
        }
        draft.firstActiveUpdatedTimestamp = Date.now();
        return draft;
    });
const $58987587447d73e1$var$FIRST_ACTIVE_NOT_APPLICABLE = Symbol('FIRST_ACTIVE_NOT_APPLICABLE');
const $58987587447d73e1$var$getProductFirstActiveTraitValue = (product, traitsByName)=>{
    switch(product){
        case 'jira':
            return traitsByName['jira_first_active'] || traitsByName['jira-software_first_active'];
        case 'confluence':
            return traitsByName['confluence_first_active'];
        case 'home':
            return $58987587447d73e1$var$FIRST_ACTIVE_NOT_APPLICABLE;
        default:
            product; // Should never get here - handle all products above!
    }
};
const $58987587447d73e1$export$8788f7a1e6d8fdb0 = (targetProducts, dynamicEligibility)=>!!dynamicEligibility && targetProducts.some((product)=>dynamicEligibility.access[product] === true && dynamicEligibility.visibility[product] === true);
const $58987587447d73e1$export$8ec65f29d950d5d3 = ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = {};
    for (const apsKey of limitToOnlyApsKeys){
        const app = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
        const { promotedLink: promotedLink, links: links, status: status } = getFilteredProductLinks(apsKey);
        if (status === 'complete') {
            const hasAccess = Boolean(promotedLink || links.length > 0);
            access[app] = hasAccess;
        }
    }
    return access;
};
const $58987587447d73e1$var$menuIdToApsKey = {
    // Jira to Confluence
    'jira.sidebar.globalApp.confluence': 'CONFLUENCE',
    // Confluence to Jira
    jiraShortcut: 'JIRA_SOFTWARE'
};
const $58987587447d73e1$export$ef01d2a4fe4032bb = ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = Object.values(shortcuts).reduce((acc, shortcut)=>{
        if (shortcut.type === 'link' && shortcut.apsKey) {
            const { apsKey: apsKey, url: url } = shortcut;
            // if the url is valid then we assume the user has access to the product
            if (url && limitToOnlyApsKeys.includes(apsKey)) try {
                const appKey = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
                acc[appKey] = true;
            // eslint-disable-next-line no-unused-vars
            } catch (_) {
            // if fails to get the app key then it's not an allowed app, skip it
            }
        }
        return acc;
    }, {});
    return $58987587447d73e1$var$applyDefaultsForApsKeys(access, limitToOnlyApsKeys, false);
};
const $58987587447d73e1$var$applyDefaultsForApsKeys = (appMap, apsKeys, defaultValue)=>{
    const result = {
        ...appMap
    };
    for (let apsKey of apsKeys){
        const app = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
        if (result[app] === undefined) result[app] = defaultValue;
    }
    return result;
};
const $58987587447d73e1$export$a8f7dcbfec997a77 = ({ visibleMenuIds: visibleMenuIds, limitToOnlyApsKeys: apsKeys = [
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const visibleApsKeys = new Set(visibleMenuIds.map((menuId)=>$58987587447d73e1$var$menuIdToApsKey[menuId]).filter(Boolean));
    const visibilityMap = {};
    for (const apsKey of apsKeys){
        const appKey = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
        visibilityMap[appKey] = visibleApsKeys.has(apsKey);
    }
    return visibilityMap;
};
const $58987587447d73e1$export$1c471c34a84a4f55 = async ({ access: accessMap, visibility: visibilityMap, cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        let updated = false;
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const app of (0, $74915a9b8039531c$export$12e73c04b5fd5da2)){
            const appAccess = accessMap[app];
            const appVisibility = visibilityMap[app];
            const prevApp = draft.apps[app] ?? {};
            if (appAccess !== undefined && appAccess !== prevApp.access || appVisibility !== undefined && appVisibility !== prevApp.visible) {
                const draftApp = {
                    ...prevApp,
                    access: appAccess,
                    visible: appVisibility
                };
                draft.apps[app] = draftApp;
                updated = true;
            }
        }
        return updated ? draft : null;
    });
const $58987587447d73e1$export$e238a4387f5f61d6 = async ({ productsSeen: productsSeen, seenTimestamp: seenTimestamp = Date.now(), cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        let updated = false;
        for (const product of productsSeen){
            const prevApp = draft.apps[product];
            if (!prevApp?.firstImpressionAt) {
                updated = true;
                draft.apps[product] = {
                    ...prevApp,
                    firstImpressionAt: seenTimestamp
                };
            }
        }
        return updated ? draft : null;
    });
const $58987587447d73e1$export$a3cc74cdee943c7f = async ({ cache: cache, product: product, timestamp: timestamp = Date.now() })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        draft.apps[product] = {
            ...draft.apps[product],
            firstActive: timestamp
        };
        return draft;
    });
const $58987587447d73e1$export$606587d4eb77e23d = async ({ products: products, collaboratorsWithProducts: collaboratorsWithProducts, cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const collaboratorsByProduct = $58987587447d73e1$var$groupCollaboratorsByProduct(collaboratorsWithProducts);
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const product of products){
            const collabs = collaboratorsByProduct[product] ?? [];
            draft.apps[product] = {
                ...draft.apps[product],
                // We display:
                // - 1x avatar for 1 collaborator
                // - 2x avatars for exactly 2 collaborators
                // - 1x avatar + number of remaining collaborators for 3+
                // So store exactly as much detailed data as we need to display:
                collaboratorDetails: collabs.slice(0, collabs.length === 2 ? 2 : 1).map((c)=>({
                        avatar: c.avatar
                    })),
                collaboratorCount: collabs.length
            };
        }
        return draft;
    });
const $58987587447d73e1$var$groupCollaboratorsByProduct = (collaboratorsWithProducts)=>{
    const result = {};
    for (const cwp of collaboratorsWithProducts)for (const product of cwp.products){
        if (!result[product]) result[product] = [];
        result[product].push(cwp.collaborator);
    }
    return result;
};
const $58987587447d73e1$var$groupTraitsByName = (traits)=>{
    const traitsByName = {};
    for (const trait of traits)traitsByName[trait.name] = trait.value;
    return traitsByName;
};
const $58987587447d73e1$export$bca6124add6e242 = (traitValue)=>typeof traitValue === 'string' && +new Date(traitValue) || null;






const $77489821c279a9fb$export$55467fcd9e2bb73a = ()=>{
    const canWriteRef = (0, $42omo.useRef)(null);
    return (0, $42omo.useCallback)(async ({ cache: cache })=>{
        if (canWriteRef.current === null) canWriteRef.current = $77489821c279a9fb$var$canWriteToCache({
            cache: cache
        });
        return await canWriteRef.current;
    }, []);
};
/**
 * This implementation does retries.
 *
 * Needed because the browser control library's async `setCookie()` function
 * has a bug/limitation when it doesn't correctly wait for the product context
 * to init. If we call the function "too early", it says the cookie is blocked
 * and doesn't do the write, even though once the product context loads,
 * the write would succeed.
 */ const $77489821c279a9fb$var$canWriteToCache = async ({ maxRetries: maxRetries = 2, retry: retry = 0, retryDelay: retryDelay = 1000, cache: cache })=>{
    try {
        const initialRead = cache.read({
            ssr: false
        });
        const writtenId = (initialRead?.[0, $74915a9b8039531c$export$fd93bc3ed8f14580] ?? 0) + 1;
        const writeResult = await cache.write({
            ...initialRead,
            [(0, $74915a9b8039531c$export$fd93bc3ed8f14580)]: writtenId
        });
        const wroteSuccessfully = writeResult === true && cache.read({
            ssr: false
        })?.[0, $74915a9b8039531c$export$fd93bc3ed8f14580] === writtenId;
        if (!wroteSuccessfully && retry < maxRetries) {
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return await $77489821c279a9fb$var$canWriteToCache({
                retry: retry + 1,
                maxRetries: maxRetries,
                retryDelay: retryDelay,
                cache: cache
            });
        }
        return wroteSuccessfully;
    } catch  {
        return false;
    }
};


const $e0f55f0500dfbf3c$export$c2e2a02c27ed0bc1 = (input)=>(0, $dh538.fg)('twcg-460-ssr-fix-evaluation') ? $e0f55f0500dfbf3c$var$useInvitedAppShortcutsStateless(input) : $e0f55f0500dfbf3c$var$useInvitedAppShortcutsLegacy(input);
const $e0f55f0500dfbf3c$var$areOptionalBooleanMapsEqual = (left, right)=>{
    // Compare only known map values; this avoids the overhead of generic deep equality.
    const keys = new Set([
        ...Object.keys(left),
        ...Object.keys(right)
    ]);
    for (const key of keys){
        if (left[key] !== right[key]) return false;
    }
    return true;
};
const $e0f55f0500dfbf3c$var$useInvitedAppShortcutsLegacy = ({ enabled: enabled, sourceProduct: sourceProduct, targetProducts: targetProducts, cloudId: cloudId, userId: userId, onCacheNeedsRefresh: onCacheNeedsRefresh, traits: traitsArg, fetchTraits: fetchTraits, fetchTraitsPolicy: fetchTraitsPolicy, cache: cache })=>{
    const { fireInvitedAppShortcutsEligibilityChecked: fireInvitedAppShortcutsEligibilityChecked, fireFeatureExposed: fireFeatureExposed, fireFetchInvitedAppShortcutsTraitsSucceeded: fireFetchInvitedAppShortcutsTraitsSucceeded, fireFetchInvitedAppShortcutsTraitsFailed: fireFetchInvitedAppShortcutsTraitsFailed, fireFetchCollaboratorsAccessSucceeded: fireFetchCollaboratorsAccessSucceeded, fireFetchCollaboratorsAccessFailed: fireFetchCollaboratorsAccessFailed, fireEligibilityUpdateSucceeded: fireEligibilityUpdateSucceeded, fireEligibilityUpdateFailed: fireEligibilityUpdateFailed } = (0, $87q77.useInvitedAppAnalytics)();
    // TODO: add option that would pre-filter the app items that might be displayed in the menu
    // (based e.g. on license info or menu configuration)
    const canWriteToCache = (0, $77489821c279a9fb$export$55467fcd9e2bb73a)();
    const [traitsState, setTraitsState] = (0, $42omo.useState)(()=>traitsArg ? {
            status: 'complete',
            traits: traitsArg
        } : {
            status: 'initial'
        });
    const [dynamicEligibility, setDynamicEligibility] = (0, $42omo.useState)(null);
    const [cached] = (0, $42omo.useState)(()=>{
        if (enabled) try {
            return (0, $58987587447d73e1$export$2331136d2a146e0b)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                cache: cache,
                userId: userId
            });
        // eslint-disable-next-line no-unused-vars
        } catch (_ignoredError) {
            return {
                eligibility: (0, $58987587447d73e1$export$16cb62545527283a)((0, $74915a9b8039531c$export$130cf0f0f2a54797).ERROR)
            };
        }
        else return {
            eligibility: (0, $58987587447d73e1$export$16cb62545527283a)((0, $74915a9b8039531c$export$130cf0f0f2a54797).EXPERIMENT_OFF)
        };
    });
    // Fetch traits
    // if we've already established that user has eligible access to target products
    (0, $42omo.useEffect)(()=>{
        (async function maybeFetchTraits() {
            if (!(enabled && userId && traitsState.status === 'initial' && (0, $58987587447d73e1$export$8788f7a1e6d8fdb0)(targetProducts, dynamicEligibility))) return;
            const cacheNeedsRefresh = doesCacheNeedRefresh();
            if ((cacheNeedsRefresh || fetchTraits && fetchTraitsPolicy === 'always-fetch') && await canWriteToCache({
                cache: cache
            })) {
                if (cacheNeedsRefresh) onCacheNeedsRefresh?.();
                if (fetchTraits) {
                    setTraitsState({
                        status: 'loading'
                    });
                    try {
                        const traits = await fetchTraits({
                            cloudId: cloudId,
                            userId: userId
                        });
                        setTraitsState({
                            status: 'complete',
                            traits: traits
                        });
                        fireFetchInvitedAppShortcutsTraitsSucceeded({
                            sourceApp: sourceProduct,
                            targetApps: targetProducts
                        });
                    } catch (error) {
                        setTraitsState({
                            status: 'error',
                            error: error
                        });
                        fireFetchInvitedAppShortcutsTraitsFailed({
                            sourceApp: sourceProduct,
                            targetApps: targetProducts
                        });
                    }
                }
            }
        })();
        function doesCacheNeedRefresh() {
            return cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY || cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY_USER_MISMATCH || cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EXPIRED || (0, $58987587447d73e1$export$fe1089e917806f3c)(cached.state);
        }
    }, [
        cached.eligibility.ineligibilityReason,
        cached.state,
        canWriteToCache,
        cache,
        cloudId,
        userId,
        enabled,
        dynamicEligibility,
        fetchTraits,
        fetchTraitsPolicy,
        onCacheNeedsRefresh,
        traitsState.status,
        fireFetchInvitedAppShortcutsTraitsSucceeded,
        fireFetchInvitedAppShortcutsTraitsFailed,
        sourceProduct,
        targetProducts
    ]);
    // Synchronize traits state with the supplied traits arg
    (0, $42omo.useEffect)(()=>{
        if (enabled && traitsState.status !== 'complete' && traitsArg) setTraitsState({
            status: 'complete',
            traits: traitsArg
        });
    }, [
        enabled,
        traitsArg,
        traitsState.status
    ]);
    // Update state once we got all the data to update eligibility
    (0, $42omo.useEffect)(()=>{
        (async function mainEligibilityUpdate() {
            if (enabled && userId && traitsState.status === 'complete' && dynamicEligibility !== null) try {
                const updatedCacheState = await (0, $58987587447d73e1$export$b97783bc9c26cb8b)({
                    traits: traitsState.traits,
                    access: dynamicEligibility.access,
                    visibility: dynamicEligibility.visibility,
                    userId: userId,
                    cache: cache
                });
                const updatedEligibility = (0, $58987587447d73e1$export$6d313cb53294e81)({
                    sourceProduct: sourceProduct,
                    targetProducts: targetProducts
                }, updatedCacheState);
                const willNowBeEligible = updatedEligibility.ineligibilityReason === null;
                if (willNowBeEligible && (0, $a834e0c1c192b1ad$export$9db1624a8af791a4)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false, {
                    fireExperimentExposure: false
                })) {
                    const products = (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS);
                    const collaboratorsAccess = await (0, $dd5e2face8bc024d$export$5391c0e0cb095e8a)({
                        products: products,
                        cloudId: cloudId,
                        userId: userId
                    }).then((collaboratorsAccess)=>{
                        fireFetchCollaboratorsAccessSucceeded({
                            sourceApp: sourceProduct,
                            targetApps: targetProducts,
                            collaborators: collaboratorsAccess.length
                        });
                        return collaboratorsAccess;
                    }).catch((error)=>{
                        fireFetchCollaboratorsAccessFailed({
                            sourceApp: sourceProduct,
                            targetApps: targetProducts,
                            error: error instanceof Error ? error.message : `${error}`
                        });
                        // fallback to empty collaborators access rather than failing the whole process
                        return [];
                    });
                    (0, $58987587447d73e1$export$606587d4eb77e23d)({
                        collaboratorsWithProducts: collaboratorsAccess,
                        products: products,
                        cache: cache
                    });
                }
                fireEligibilityUpdateSucceeded({
                    sourceApp: sourceProduct,
                    targetApps: targetProducts
                });
            } catch (error) {
                fireEligibilityUpdateFailed({
                    sourceApp: sourceProduct,
                    targetApps: targetProducts,
                    error: error instanceof Error ? error.message : `${error}`
                });
            }
        })();
    }, [
        cache,
        enabled,
        dynamicEligibility,
        traitsState,
        userId,
        cloudId,
        sourceProduct,
        targetProducts,
        fireFetchCollaboratorsAccessSucceeded,
        fireFetchCollaboratorsAccessFailed,
        fireEligibilityUpdateSucceeded,
        fireEligibilityUpdateFailed
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && cached.eligibility.ineligibilityReason) fireInvitedAppShortcutsEligibilityChecked({
            ineligibilityReason: cached.eligibility.ineligibilityReason,
            userId: userId,
            cloudId: cloudId
        });
    }, [
        enabled,
        cached.eligibility.ineligibilityReason,
        fireInvitedAppShortcutsEligibilityChecked,
        userId,
        cloudId
    ]);
    return (0, $42omo.useMemo)(()=>{
        const getEligibleInvitedApps = ()=>Object.keys(cached.eligibility.invitedApps || {}).filter((appName)=>cached.eligibility.invitedApps?.[appName]?.eligible);
        const updateFromDynamicEligibility = ({ access: access, visibility: visibility })=>{
            const newDynamicEligibility = {
                access: access,
                visibility: visibility
            };
            // Only update state/cache when one of the resolved app flags actually changed.
            const hasDynamicEligibilityChanged = !dynamicEligibility || !$e0f55f0500dfbf3c$var$areOptionalBooleanMapsEqual(dynamicEligibility.access, access) || !$e0f55f0500dfbf3c$var$areOptionalBooleanMapsEqual(dynamicEligibility.visibility, visibility);
            if (enabled && hasDynamicEligibilityChanged) {
                setDynamicEligibility(newDynamicEligibility);
                (0, $58987587447d73e1$export$1c471c34a84a4f55)({
                    access: access,
                    visibility: visibility,
                    cache: cache
                });
            }
        };
        return {
            ...cached.eligibility,
            /**
			 * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
			 *
			 * It will update our eligibility cache based on app access info from the BFF,
			 * using that filter function.
			 */ updateFromAppAccessFilter: ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                if (!enabled) return;
                const access = (0, $58987587447d73e1$export$8ec65f29d950d5d3)({
                    getFilteredProductLinks: getFilteredProductLinks,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $58987587447d73e1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            updateFromHydratedShortcuts: ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                if (!enabled) return;
                const access = (0, $58987587447d73e1$export$ef01d2a4fe4032bb)({
                    shortcuts: shortcuts,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $58987587447d73e1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            registerImpression: ({ products: products = getEligibleInvitedApps() } = {})=>{
                if (enabled) (0, $58987587447d73e1$export$e238a4387f5f61d6)({
                    productsSeen: products,
                    cache: cache
                });
            },
            registerActivation: (product)=>{
                if (enabled) (0, $58987587447d73e1$export$a3cc74cdee943c7f)({
                    product: product,
                    cache: cache
                });
            },
            fireFeatureExposed: (input)=>{
                if (enabled) fireFeatureExposed({
                    ...input,
                    userId: userId,
                    cloudId: cloudId
                });
            }
        };
    }, [
        cache,
        cached.eligibility,
        enabled,
        dynamicEligibility,
        fireFeatureExposed,
        userId,
        cloudId
    ]);
};
/**
 * Main hook to return and establish eligibility for Invited App Shortcuts.
 *
 * Returns a cached, stable, non-Reactive eligibility from the very first render (SSR/Hydration),
 * based on what it reads from the cookie cache.
 *
 * On first visit, when the cache is empty (or outdated), it will return an ineligibility.
 * Then, the hook establishes eligibility in the background, and updates the cache for the next visit.
 *
 * Eligibility requirements are fused from multiple sources:
 * - Dynamic data coming from Nav/Switcher Backend-for-Frontend (BFF).
 *   This is updated on every visit because we get it "for free" (Nav calls the BFF anyway).
 *   Includes:
 * 	  - **Access** - whether the user has access to the target app(s)
 *    - **Visibility** - whether the user configured the target app's shortcut to be visible or not visible.
 *      By default, apps are visible, but there's an experiment that hides all of them for the first week
 *      of the instance.
 * - Deep refresh data, specific to Invited App Shortcuts, which is more costly to establish
 *   and is therefore cached in the cookie and refreshed only once a week.
 *   Includes:
 *   - **Traits** - used to confirm that the user has been active in the source product for long enough,
 *     and that they haven't been active in the target product yet.
 *     In Jira, traits are passed via a `fetchTraits` function (Jira has a standard function that's
 *     cached in memory).
 *     In Confluence, traits are passed as the `traits` arg, and they come from a Confluence GraphQL query.
 *   - **Collaborators** - number of collaborators in the target product. You can still be eligible
 *     with zero collaborators, but we'll show you a different treatment.
 *
 * If the `enabled` option is false, this hook does nothing.
 *
 * Returns current eligibility details, and API to update eligibility.
 */ const $e0f55f0500dfbf3c$var$useInvitedAppShortcutsStateless = ({ enabled: enabled, sourceProduct: sourceProduct, targetProducts: targetProducts, cloudId: cloudId, userId: userId, onCacheNeedsRefresh: onCacheNeedsRefresh, traits: traitsArg, fetchTraits: fetchTraits, fetchTraitsPolicy: fetchTraitsPolicy, cache: cache })=>{
    // This implementation prioritizes peformance: avoiding re-renders and state updates.
    // That's why it doesn't have dynamic React state at all.
    // TODO: add option that would pre-filter the app items that might be displayed in the menu
    // (based e.g. on license info or menu configuration)
    const analytics = (0, $87q77.useInvitedAppAnalytics)();
    const canWriteToCache = (0, $77489821c279a9fb$export$55467fcd9e2bb73a)();
    /**
	 * Stores traits fetch status.
	 *
	 * Resolved from props: either directly from `traits` or from `fetchTraits`.
	 */ const traitsDeferredRef = (0, $42omo.useRef)(// Memoize initial ref value to compute it only once:
    (0, $42omo.useMemo)(()=>{
        let resolve;
        const promise = new Promise((res)=>{
            resolve = res;
        });
        return {
            promise: promise,
            resolve: resolve,
            status: 'initial'
        };
    }, []));
    /**
	 * A lock preventing duplicate cache refreshes.
	 */ const isCacheRefreshLockedRef = (0, $42omo.useRef)(false);
    /**
	 * Main read from the cache to resolve the returned eligibility
	 *
	 * Read only once, and then stable (non-reactive), ensured by useState with a functional initializer.
	 */ const [cached] = (0, $42omo.useState)(()=>{
        if (enabled) try {
            return (0, $58987587447d73e1$export$2331136d2a146e0b)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                cache: cache,
                userId: userId
            });
        // eslint-disable-next-line no-unused-vars
        } catch (_ignoredError) {
            return {
                eligibility: (0, $58987587447d73e1$export$16cb62545527283a)((0, $74915a9b8039531c$export$130cf0f0f2a54797).ERROR)
            };
        }
        else return {
            eligibility: (0, $58987587447d73e1$export$16cb62545527283a)((0, $74915a9b8039531c$export$130cf0f0f2a54797).EXPERIMENT_OFF)
        };
    });
    /**
	 * Synchronize traits state with the supplied traits arg.
	 *
	 * This arg is passed by Confluence, based on a Confluence GraphQL query. The query
	 * is initially skipped. It stops being skipped when our hook calls `onCacheNeedsRefresh`,
	 * which it does only when it decides that the cache needs a refresh.
	 */ (0, $42omo.useEffect)(()=>{
        if (enabled && traitsArg && traitsDeferredRef.current.status === 'initial') {
            traitsDeferredRef.current.resolve(traitsArg);
            traitsDeferredRef.current.status = 'fulfilled';
        }
    }, [
        enabled,
        traitsArg
    ]);
    /**
	 * Fire analytics when the user is ineligible
	 */ (0, $42omo.useEffect)(()=>{
        if (enabled && cached.eligibility.ineligibilityReason) analytics.fireInvitedAppShortcutsEligibilityChecked({
            ineligibilityReason: cached.eligibility.ineligibilityReason,
            userId: userId,
            cloudId: cloudId
        });
    }, [
        enabled,
        cached.eligibility.ineligibilityReason,
        analytics,
        userId,
        cloudId
    ]);
    return (0, $42omo.useMemo)(()=>{
        const updateFromDynamicEligibility = async ({ access: access, visibility: visibility })=>{
            if (!enabled || !userId) return;
            (0, $58987587447d73e1$export$1c471c34a84a4f55)({
                access: access,
                visibility: visibility,
                cache: cache
            });
            await $e0f55f0500dfbf3c$var$maybeRefreshEligibility({
                access: access,
                visibility: visibility,
                cache: cache,
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                traitsDeferred: traitsDeferredRef.current,
                obtainRefreshLock: obtainRefreshLock,
                userId: userId,
                cloudId: cloudId,
                cached: cached,
                canWriteToCache: canWriteToCache,
                onCacheNeedsRefresh: onCacheNeedsRefresh,
                fetchTraits: fetchTraits,
                fetchTraitsPolicy: fetchTraitsPolicy,
                analytics: analytics
            });
        };
        /**
		 * One-way lock only (no ability to unlock) because we want to make sure we only
		 * do a deep cache refresh once.
		 */ const obtainRefreshLock = ()=>{
            if (isCacheRefreshLockedRef.current) return false;
            isCacheRefreshLockedRef.current = true;
            return true;
        };
        const getEligibleInvitedApps = ()=>Object.keys(cached.eligibility.invitedApps || {}).filter((appName)=>cached.eligibility.invitedApps?.[appName]?.eligible);
        return {
            ...cached.eligibility,
            /**
			 * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
			 *
			 * It will update our eligibility cache based on app access info from the BFF,
			 * using that filter function.
			 *
			 * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
			 * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
			 */ updateFromAppAccessFilter: ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                if (!enabled) return;
                const access = (0, $58987587447d73e1$export$8ec65f29d950d5d3)({
                    getFilteredProductLinks: getFilteredProductLinks,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $58987587447d73e1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
			 * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
			 *
			 * It will update our eligibility cache based on app access info from the BFF,
			 * using that filter function.
			 *
			 * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
			 * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
			 */ updateFromHydratedShortcuts: ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                if (!enabled) return;
                const access = (0, $58987587447d73e1$export$ef01d2a4fe4032bb)({
                    shortcuts: shortcuts,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $58987587447d73e1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
			 * Call when the user has seen our invited app shortcut in the UI.
			 *
			 * Adds `firstImpressionAt` info to the cache. UI reads that to only
			 * show the `Invited` lozenge animation once (when there hasn't been
			 * a previous impression).
			 */ registerImpression: ({ products: products = getEligibleInvitedApps() } = {})=>{
                if (enabled) (0, $58987587447d73e1$export$e238a4387f5f61d6)({
                    productsSeen: products,
                    cache: cache
                });
            },
            /**
			 * Call when the user converted, i.e. clicked on our invited app shortcut
			 * and went on to activate in the target product.
			 *
			 * Used to mark the user as ineligible so that the treatment does not show up
			 * on the next visit, without having to wait for cache to expire.
			 */ registerActivation: (product)=>{
                if (enabled) (0, $58987587447d73e1$export$a3cc74cdee943c7f)({
                    product: product,
                    cache: cache
                });
            },
            /**
			 * Fire exposure analytics (when the user is eligible).
			 */ fireFeatureExposed: (input)=>{
                if (enabled) analytics.fireFeatureExposed({
                    ...input,
                    userId: userId,
                    cloudId: cloudId
                });
            }
        };
    }, [
        cache,
        cached,
        enabled,
        userId,
        cloudId,
        sourceProduct,
        targetProducts,
        canWriteToCache,
        onCacheNeedsRefresh,
        fetchTraits,
        fetchTraitsPolicy,
        analytics
    ]);
};
/**
 * Main cache refresh flow.
 *
 * Triggers a deep cache refresh (fetch traits, collaborators), but only if
 * access/eligibility prefilters indicate possible eligibility, and cache is empty
 * or needs refresh.
 */ async function $e0f55f0500dfbf3c$var$maybeRefreshEligibility({ traitsDeferred: traitsDeferred, analytics: analytics, visibility: visibility, access: access, sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cloudId: cloudId, cache: cache, cached: cached, canWriteToCache: canWriteToCache, onCacheNeedsRefresh: onCacheNeedsRefresh, obtainRefreshLock: obtainRefreshLock, fetchTraits: fetchTraits, fetchTraitsPolicy: fetchTraitsPolicy }) {
    if ((0, $58987587447d73e1$export$8788f7a1e6d8fdb0)(targetProducts, {
        visibility: visibility,
        access: access
    })) {
        const cacheNeedsRefresh = doesCacheNeedRefresh();
        const shouldRefresh = cacheNeedsRefresh || fetchTraits && fetchTraitsPolicy === 'always-fetch';
        if (shouldRefresh && await canWriteToCache({
            cache: cache
        }) && obtainRefreshLock()) {
            if (cacheNeedsRefresh) onCacheNeedsRefresh?.();
            await refreshEligibility();
        }
    }
    function doesCacheNeedRefresh() {
        return cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY || cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY_USER_MISMATCH || cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EXPIRED || (0, $58987587447d73e1$export$fe1089e917806f3c)(cached.state);
    }
    async function refreshEligibility() {
        try {
            const traits = await getTraits();
            const updatedCacheState = await (0, $58987587447d73e1$export$b97783bc9c26cb8b)({
                traits: traits,
                access: access,
                visibility: visibility,
                userId: userId,
                cache: cache
            });
            const updatedEligibility = (0, $58987587447d73e1$export$6d313cb53294e81)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts
            }, updatedCacheState);
            const willNowBeEligible = updatedEligibility.ineligibilityReason === null;
            if (willNowBeEligible && (0, $a834e0c1c192b1ad$export$9db1624a8af791a4)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false, {
                fireExperimentExposure: false
            })) {
                const products = (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS);
                const collaboratorsAccess = await getCollaborators({
                    products: products
                });
                (0, $58987587447d73e1$export$606587d4eb77e23d)({
                    collaboratorsWithProducts: collaboratorsAccess,
                    products: products,
                    cache: cache
                });
            }
            analytics.fireEligibilityUpdateSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
        } catch (error) {
            analytics.fireEligibilityUpdateFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
        }
    }
    async function getTraits() {
        if (traitsDeferred.status !== 'initial' || !fetchTraits) return traitsDeferred.promise;
        traitsDeferred.status = 'loading';
        try {
            const traitsPromise = fetchTraits({
                cloudId: cloudId,
                userId: userId
            });
            // Resolving with traitsPromise adopts traitsPromise's fulfillment/rejection:
            traitsDeferred.resolve(traitsPromise);
            const traits = await traitsDeferred.promise;
            traitsDeferred.status = 'fulfilled';
            analytics.fireFetchInvitedAppShortcutsTraitsSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            return traits;
        } catch (error) {
            traitsDeferred.status = 'rejected';
            analytics.fireFetchInvitedAppShortcutsTraitsFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            throw error;
        }
    }
    async function getCollaborators({ products: products }) {
        return (0, $dd5e2face8bc024d$export$5391c0e0cb095e8a)({
            products: products,
            cloudId: cloudId,
            userId: userId
        }).then((collaboratorsAccess)=>{
            analytics.fireFetchCollaboratorsAccessSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                collaborators: collaboratorsAccess.length
            });
            return collaboratorsAccess;
        }).catch((error)=>{
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
            // fallback to empty collaborators access rather than failing the whole process
            return [];
        });
    }
}



var $68uaC = parcelRequire("68uaC");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $082cea242d4d809f$var$targetProducts = [
    'jira'
];
const $082cea242d4d809f$export$e6614be55e8365cd = ()=>{
    const $ = (0, $frIzR.c)(12);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [cacheNeedsRefresh, setCacheNeedsRefresh] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] !== cacheNeedsRefresh) {
        t0 = (0, $9wGTI.fg)("twcg-460-personalised-invite-notifications-m2-gate") && cacheNeedsRefresh;
        $[0] = cacheNeedsRefresh;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !t0;
    const t2 = userId || "";
    let t3;
    if ($[2] !== cloudId || $[3] !== t2) {
        t3 = {
            cloudId: cloudId,
            userId: t2
        };
        $[2] = cloudId;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3) {
        t4 = {
            skip: t1,
            variables: t3
        };
        $[5] = t1;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const userTraits = (0, $gqypm.useExperimentalSiteUserPersonalization)(t4);
    let t5;
    if ($[8] !== cloudId || $[9] !== userId || $[10] !== userTraits) {
        t5 = (0, $9wGTI.fg)("twcg-460-personalised-invite-notifications-m2-gate") ? {
            enabled: true,
            targetProducts: $082cea242d4d809f$var$targetProducts,
            sourceProduct: "confluence",
            cloudId: cloudId,
            userId: userId,
            traits: userTraits.data?.experimentalSiteUserPersonalization?.attributes ?? null,
            cache: $082cea242d4d809f$export$5e0574c563aa74b8(),
            onCacheNeedsRefresh: ()=>{
                setCacheNeedsRefresh(true);
            }
        } : {
            enabled: false
        };
        $[8] = cloudId;
        $[9] = userId;
        $[10] = userTraits;
        $[11] = t5;
    } else t5 = $[11];
    return (0, $e0f55f0500dfbf3c$export$c2e2a02c27ed0bc1)(t5);
};
let $082cea242d4d809f$var$cache;
const $082cea242d4d809f$export$5e0574c563aa74b8 = ()=>{
    if (!$082cea242d4d809f$var$cache) $082cea242d4d809f$var$cache = new (0, $3438e954aa0087f3$export$7bddb475c47d45d)({
        setCookie: (0, $68uaC.Cookies).set,
        getCookie: (0, $68uaC.Cookies).get
    });
    return $082cea242d4d809f$var$cache;
};
module.exports["useResolveInvitedAppShortcuts"] = $082cea242d4d809f$export$e6614be55e8365cd;

});

parcelRegister("166II", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $jrref = parcelRequire("jrref");

var $iXCQx = parcelRequire("iXCQx");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");


var $lsxnT = parcelRequire("lsxnT");

var $2ff731f9901765b7$exports = {};
$2ff731f9901765b7$exports = new URL("Home.eb3dbfc7.gif", import.meta.url).toString();


var $aaa2d9cdc909fccc$exports = {};
$aaa2d9cdc909fccc$exports = new URL("Home-dark.b4541437.gif", import.meta.url).toString();



var $3Awqk = parcelRequire("3Awqk");


var $3SChL = parcelRequire("3SChL");


var $2AgON = parcelRequire("2AgON");

var $45d79bcc480adcc3$exports = {};
$45d79bcc480adcc3$exports = new URL("Home-placeholder.72eb75ff.png", import.meta.url).toString();


var $43c7d0807c4785cf$exports = {};
$43c7d0807c4785cf$exports = new URL("Home-placeholder-dark.86521bfc.png", import.meta.url).toString();



var $35Nok = parcelRequire("35Nok");

const $3472cc1e48bf28c2$var$STEP_ID = 'nth-user-orientation-editor-for-you-spotlight';
const $3472cc1e48bf28c2$export$9cb1114290a9ed04 = ({ children: children })=>{
    const { reset: reset, next: next, back: back, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($3472cc1e48bf28c2$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isVisible = currentStep === $3472cc1e48bf28c2$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($2ff731f9901765b7$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($aaa2d9cdc909fccc$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($45d79bcc480adcc3$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($43c7d0807c4785cf$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleBack: handleBack, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $3472cc1e48bf28c2$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onBack: back,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        next: handleNext,
        back: handleBack,
        dismiss: handleDismiss,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $3472cc1e48bf28c2$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $3472cc1e48bf28c2$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorForYouSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorForYouSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), null, formatMessage((0, $3Awqk.spotlight).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next))))))))));
};
module.exports["EditorForYouSpotlight"] = $3472cc1e48bf28c2$export$9cb1114290a9ed04;

});

parcelRegister("4ByCJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $gnkil = parcelRequire("gnkil");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $efvKr = parcelRequire("efvKr");


var $9vJRo = parcelRequire("9vJRo");


var $de2j9 = parcelRequire("de2j9");


var $166II = parcelRequire("166II");


var $frIzR = parcelRequire("frIzR");





var $6GD8y = parcelRequire("6GD8y");




const $d2fc0c31cdd9908e$export$65c30f73882c92dc = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { href: href, keyboardShortcut: keyboardShortcut, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, isAppNavigationShortcut: isAppNavigationShortcut, children: children } = t0;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== href || $[1] !== push) {
        t1 = ()=>{
            href && push(href);
        };
        $[0] = href;
        $[1] = push;
        $[2] = t1;
    } else t1 = $[2];
    const listenerCallback = t1;
    let t2;
    if ($[3] !== deprecatedKeyboardShortcut || $[4] !== isAppNavigationShortcut || $[5] !== keyboardShortcut || $[6] !== listenerCallback) {
        t2 = keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: deprecatedKeyboardShortcut,
            accelerator: keyboardShortcut,
            listener: listenerCallback,
            isAppNavigationShortcut: isAppNavigationShortcut || false
        });
        $[3] = deprecatedKeyboardShortcut;
        $[4] = isAppNavigationShortcut;
        $[5] = keyboardShortcut;
        $[6] = listenerCallback;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== children || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children, t2);
        $[8] = children;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
});



var $iQcdJ = parcelRequire("iQcdJ");


var $26Pni = parcelRequire("26Pni");


var $eLFsG = parcelRequire("eLFsG");


var $XO4by = parcelRequire("XO4by");


const $b9f550940f484a79$export$17b89e6a36c6b530 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "RR3ov",
    name: "StarredContentMenuLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("1IQhI")))).StarredContentMenu
});

const $b9f550940f484a79$export$af1f39df90a1145e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8g6fk",
    name: "RecentContentMenuLoader",
    loader: async ()=>(await (parcelRequire("1NFFE"))).RecentContentMenu
});
const $b9f550940f484a79$export$f29dcc074aa4bb66 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const homeUrl = (0, $1NBp8.HOME).toUrl();
    const isHomeSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnHomeSelector);
    const isRecentOpenRef = (0, $42omo.useRef)(false);
    const recentsFilterConfig = (0, $iQcdJ.useRecentsFilterConfig)();
    const recentViewAllUrl = (0, $1NBp8.HOME).toUrl({
        view: 'recent'
    });
    const isRecentSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnRecentRoute);
    const onRecentMouseEnter = (0, $42omo.useCallback)(()=>{
        if (!isRecentOpenRef.current) {
            $b9f550940f484a79$export$af1f39df90a1145e.preload();
            (0, $XO4by.preloadRecentContentMenu)(cloudId);
        }
    }, [
        cloudId
    ]);
    const isStarredOpenRef = (0, $42omo.useRef)(false);
    const starredViewAllUrl = (0, $1NBp8.HOME).toUrl({
        view: 'starred'
    });
    const isStarredSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnStarredRoute);
    const onStarredMouseEnter = (0, $42omo.useCallback)(()=>{
        if (!isStarredOpenRef.current) {
            $b9f550940f484a79$export$17b89e6a36c6b530.preload();
            (0, $eLFsG.preloadStarredContentMenu)();
        }
    }, []);
    return (0, $42omo.useMemo)(()=>({
            forYouItem: {
                type: 'link',
                menuItemId: 'yourWork',
                url: homeUrl,
                isSelected: isHomeSelected,
                ItemWrapper: ({ children: children })=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2fc0c31cdd9908e$export$65c30f73882c92dc), {
                        href: homeUrl,
                        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_HOME_SHORTCUT) : undefined,
                        keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_HOME_SHORTCUT),
                        isAppNavigationShortcut: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $166II.EditorForYouSpotlight), null, children)));
                }
            },
            recent: {
                menuItemId: 'recent',
                useItems: (0, $iQcdJ.useRecentItems),
                viewAllUrl: recentViewAllUrl,
                isSearchable: true,
                filterConfig: recentsFilterConfig,
                isSelected: isRecentSelected,
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9f550940f484a79$export$af1f39df90a1145e, null),
                onOpenChange: (isOpen)=>{
                    isRecentOpenRef.current = isOpen;
                },
                ItemWrapper: ({ children: children_0 })=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        onMouseEnter: onRecentMouseEnter,
                        onFocus: onRecentMouseEnter
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2fc0c31cdd9908e$export$65c30f73882c92dc), {
                        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_RECENT_SHORTCUT) : undefined,
                        keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
                        isAppNavigationShortcut: true
                    }, children_0));
                }
            },
            starred: {
                menuItemId: 'starred',
                useItems: (0, $26Pni.useStarredItems),
                viewAllUrl: starredViewAllUrl,
                isSearchable: true,
                isSelected: isStarredSelected,
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9f550940f484a79$export$17b89e6a36c6b530, null),
                onOpenChange: (isOpen_0)=>{
                    isStarredOpenRef.current = isOpen_0;
                },
                ItemWrapper: ({ children: children_1 })=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        onMouseEnter: onStarredMouseEnter,
                        onFocus: onStarredMouseEnter
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2fc0c31cdd9908e$export$65c30f73882c92dc), {
                        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_STARRED_SHORTCUT) : undefined,
                        keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_STARRED_SHORTCUT),
                        isAppNavigationShortcut: true
                    }, children_1));
                }
            }
        }), [
        homeUrl,
        isHomeSelected,
        isRecentSelected,
        isStarredSelected,
        recentViewAllUrl,
        recentsFilterConfig,
        starredViewAllUrl,
        isLiveEditMode,
        isOnEditRoute,
        onRecentMouseEnter,
        onStarredMouseEnter
    ]);
};
const $b9f550940f484a79$var$isOnHomeSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl() || routeUrl === (0, $1NBp8.WIKI).toUrl();
    }
};
const $b9f550940f484a79$var$isOnStarredRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'starred'
        })
};
const $b9f550940f484a79$var$isOnRecentRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'recent'
        })
};
module.exports["useForYouConfig"] = $b9f550940f484a79$export$f29dcc074aa4bb66;

});

parcelRegister("iQcdJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $jMyy4 = parcelRequire("jMyy4");


var $6a9Hv = parcelRequire("6a9Hv");


var $6bJyJ = parcelRequire("6bJyJ");


var $1yB28 = parcelRequire("1yB28");


var $1Zr9M = parcelRequire("1Zr9M");


var $6767u = parcelRequire("6767u");


var $5nBzc = parcelRequire("5nBzc");


var $bQm3c = parcelRequire("bQm3c");


var $1YXTQ = parcelRequire("1YXTQ");


var $gKr8t = parcelRequire("gKr8t");


var $2fgSf = parcelRequire("2fgSf");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $bCECL = parcelRequire("bCECL");


var $5V1fS = parcelRequire("5V1fS");


var $WG1VM = parcelRequire("WG1VM");

const $1195428fc846c248$export$bc82a767d3a2a41 = (params)=>{
    const $ = (0, $frIzR.c)(15);
    const intl = (0, $8C5kA.default)();
    const selectedFilter = params.selectedFilters?.[0] || "ALL";
    let t0;
    if ($[0] !== params.searchText || $[1] !== selectedFilter) {
        t0 = {
            searchText: params.searchText,
            selectedFilter: selectedFilter
        };
        $[0] = params.searchText;
        $[1] = selectedFilter;
        $[2] = t0;
    } else t0 = $[2];
    const { data: data, loading: loading, error: error, isUnauthorized: isUnauthorized, sections: rawSections, hasNextPage: hasNextPage, loadMore: loadMore } = $1195428fc846c248$export$5b0ada08b9b7bd62(t0);
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[3] = t2;
            } else t2 = $[3];
            t1 = t2;
            break bb0;
        }
        let result;
        if ($[4] !== intl || $[5] !== rawSections) {
            result = [];
            for (const section of rawSections){
                if (section.nodes.length === 0) continue;
                const items = [];
                for (const node of section.nodes){
                    const content = node?.object?.content;
                    const url = node?.object?.url || "";
                    const { emoji: emoji, title: title } = content ? (0, $5V1fS.getContentEmojiAndTitle)(content) : {
                        emoji: undefined,
                        title: undefined
                    };
                    const isDraft = content?.status === "draft";
                    items.push({
                        elemBefore: content?.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                            type: content.type,
                            subType: content?.subType,
                            emoji: emoji
                        }) : null,
                        elemAfter: isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
                            appearance: "default"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1195428fc846c248$export$a7357cdd1f0b0168.draftLozengeText)),
                        primaryLabel: title || intl.formatMessage((0, $5V1fS.i18n).untitled),
                        secondaryLabel: content?.space?.name || "",
                        tertiaryLabel: node?.timestamp ? (0, $1YXTQ.formatTimeAgo)(intl, node?.timestamp) : undefined,
                        href: url
                    });
                }
                result.push({
                    header: intl.formatMessage(section.title),
                    items: items
                });
            }
            $[4] = intl;
            $[5] = rawSections;
            $[6] = result;
        } else result = $[6];
        t1 = result;
    }
    const sections = t1;
    let t2;
    bb1: {
        if (isUnauthorized) {
            let t3;
            if ($[7] !== intl) {
                t3 = new Error(intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.authErrorMessageTitle));
                $[7] = intl;
                $[8] = t3;
            } else t3 = $[8];
            t2 = t3;
            break bb1;
        }
        t2 = error;
    }
    const returnError = t2;
    const t3 = loading && !data;
    let t4;
    if ($[9] !== hasNextPage || $[10] !== loadMore || $[11] !== returnError || $[12] !== sections || $[13] !== t3) {
        t4 = {
            sections: sections,
            hasMore: hasNextPage,
            isLoading: t3,
            loadMore: loadMore,
            error: returnError
        };
        $[9] = hasNextPage;
        $[10] = loadMore;
        $[11] = returnError;
        $[12] = sections;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
};
const $1195428fc846c248$export$5b0ada08b9b7bd62 = (params)=>{
    const $ = (0, $frIzR.c)(36);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = (0, $WG1VM.getQueryOptions)(cloudId);
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const queryOptions = t0;
    const selectedFilter = params.selectedFilter || "ALL";
    const searchText = params.searchText || "";
    const t1 = queryOptions[selectedFilter];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $2fgSf.shouldUseAGGActivityV3)() && {
            client: (0, $gKr8t.getAGGClient)()
        };
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== params.onCompleted || $[4] !== params.onError || $[5] !== t1.initialVars) {
        t3 = {
            variables: t1.initialVars,
            fetchPolicy: "cache-and-network",
            ...t2,
            onCompleted: params.onCompleted,
            onError: params.onError
        };
        $[3] = params.onCompleted;
        $[4] = params.onError;
        $[5] = t1.initialVars;
        $[6] = t3;
    } else t3 = $[6];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)(queryOptions[selectedFilter].query, t3);
    let t4;
    if ($[7] !== error) {
        t4 = error && (0, $1uFM6.isUnauthorizedError)(error);
        $[7] = error;
        $[8] = t4;
    } else t4 = $[8];
    const isUnauthorized = !!t4;
    let t5;
    bb0: {
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            let t6;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = [];
                $[9] = t6;
            } else t6 = $[9];
            t5 = t6;
            break bb0;
        }
        let t6;
        if ($[10] !== data || $[11] !== queryOptions || $[12] !== searchText || $[13] !== selectedFilter) {
            const lowerFilterText = searchText.toLowerCase();
            const nodes = queryOptions[selectedFilter].transformNodes(data);
            t6 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(nodes?.filter((node)=>!searchText || node?.object?.content?.title?.toLowerCase().includes(lowerFilterText)).filter($1195428fc846c248$var$_temp).filter($1195428fc846c248$var$_temp2), $1195428fc846c248$var$_temp3) ?? [];
            $[10] = data;
            $[11] = queryOptions;
            $[12] = searchText;
            $[13] = selectedFilter;
            $[14] = t6;
        } else t6 = $[14];
        t5 = t6;
    }
    const filteredNodes = t5;
    let t6;
    if ($[15] !== filteredNodes) {
        t6 = $1195428fc846c248$export$19e8d4a05b9bbef(filteredNodes);
        $[15] = filteredNodes;
        $[16] = t6;
    } else t6 = $[16];
    const sections = t6;
    const t7 = queryOptions[selectedFilter];
    let t8;
    if ($[17] !== data || $[18] !== t7) {
        t8 = t7.getPaginationParams(data);
        $[17] = data;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const { endCursor: endCursor, hasNextPage: hasNextPage } = t8;
    let t9;
    if ($[20] !== endCursor || $[21] !== fetchMore || $[22] !== hasNextPage || $[23] !== loading || $[24] !== queryOptions || $[25] !== selectedFilter) {
        t9 = ()=>{
            if (hasNextPage && endCursor && !loading) fetchMore({
                variables: queryOptions[selectedFilter].fetchMoreVars(endCursor),
                updateQuery: (prev, t10)=>{
                    const { fetchMoreResult: fetchMoreResult } = t10;
                    if (!fetchMoreResult) return prev;
                    return queryOptions[selectedFilter].updatePaginationResults(prev, fetchMoreResult);
                }
            });
        };
        $[20] = endCursor;
        $[21] = fetchMore;
        $[22] = hasNextPage;
        $[23] = loading;
        $[24] = queryOptions;
        $[25] = selectedFilter;
        $[26] = t9;
    } else t9 = $[26];
    const loadMore = t9;
    let t10;
    if ($[27] !== data || $[28] !== error || $[29] !== filteredNodes || $[30] !== hasNextPage || $[31] !== isUnauthorized || $[32] !== loadMore || $[33] !== loading || $[34] !== sections) {
        t10 = {
            data: data,
            loading: loading,
            error: error,
            isUnauthorized: isUnauthorized,
            filteredNodes: filteredNodes,
            sections: sections,
            hasNextPage: hasNextPage,
            loadMore: loadMore
        };
        $[27] = data;
        $[28] = error;
        $[29] = filteredNodes;
        $[30] = hasNextPage;
        $[31] = isUnauthorized;
        $[32] = loadMore;
        $[33] = loading;
        $[34] = sections;
        $[35] = t10;
    } else t10 = $[35];
    return t10;
};
const $1195428fc846c248$export$bf18e6ec9b4e3f2e = ()=>{
    const $ = (0, $frIzR.c)(29);
    const intl = (0, $8C5kA.default)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "ALL"
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== intl) {
        t1 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.all);
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
            label: ""
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1) {
        t3 = {
            key: "ALL",
            label: t1,
            elemBefore: t2
        };
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== intl) {
        t4 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.collaboratedOn);
        $[6] = intl;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: ""
        });
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4) {
        t6 = {
            key: "COLLABORATED_ON",
            label: t4,
            elemBefore: t5
        };
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== intl) {
        t7 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.workedOn);
        $[11] = intl;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: ""
        });
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t7) {
        t9 = {
            key: "WORKED_ON",
            label: t7,
            elemBefore: t8
        };
        $[14] = t7;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== intl) {
        t10 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.ownedByMe);
        $[16] = intl;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: ""
        });
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== t10) {
        t12 = {
            key: "CREATED_BY_ME",
            label: t10,
            elemBefore: t11
        };
        $[19] = t10;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== t12 || $[22] !== t3 || $[23] !== t6 || $[24] !== t9) {
        t13 = [
            t3,
            t6,
            t9,
            t12
        ];
        $[21] = t12;
        $[22] = t3;
        $[23] = t6;
        $[24] = t9;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = [
            "ALL"
        ];
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t13) {
        t15 = {
            defaultSelected: t0,
            filters: t13,
            hideSelectedFilterTag: t14
        };
        $[27] = t13;
        $[28] = t15;
    } else t15 = $[28];
    return t15;
};
const $1195428fc846c248$export$19e8d4a05b9bbef = (nodes)=>{
    const sections = [
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.today,
            daysAgo: 0,
            nodes: [],
            sectionId: 'today'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.yesterday,
            daysAgo: 1,
            nodes: [],
            sectionId: 'yesterday'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.lastWeek,
            daysAgo: 7,
            nodes: [],
            sectionId: 'lastWeek'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.lastMonth,
            daysAgo: 30,
            nodes: [],
            sectionId: 'lastMonth'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.moreThanMonth,
            daysAgo: -1,
            nodes: [],
            sectionId: 'moreThanMonth'
        }
    ];
    let sectionIndex = 0;
    const startOfToday = new Date().setHours(0, 0, 0, 0);
    nodes?.forEach((node)=>{
        if (!node?.timestamp) {
            sections[4].nodes.push(node);
            return;
        }
        const nodeDate = new Date(node.timestamp).getTime();
        const daysDiff = Math.floor((startOfToday - nodeDate) / (1000 * 60 * 60 * 24));
        while(sectionIndex < sections.length - 1 && daysDiff >= sections[sectionIndex].daysAgo)sectionIndex++;
        sections[sectionIndex].nodes.push(node);
    });
    return sections;
};
const $1195428fc846c248$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    today: {
        id: "side-navigation.recent-content-menu.section.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "side-navigation.recent-content-menu.section.yesterday",
        defaultMessage: "Yesterday"
    },
    lastWeek: {
        id: "side-navigation.recent-content-menu.section.last-week",
        defaultMessage: "In the last week"
    },
    lastMonth: {
        id: "side-navigation.recent-content-menu.section.last-month",
        defaultMessage: "In the last month"
    },
    moreThanMonth: {
        id: "side-navigation.recent-content-menu.section.more-than-month",
        defaultMessage: "More than a month ago"
    },
    authErrorMessageTitle: {
        id: "side-navigation.recent-content-menu.auth-error-message.title",
        defaultMessage: "You are not authorized to load recent items"
    },
    all: {
        id: "side-navigation.recent-content-menu.filter.all",
        defaultMessage: "All"
    },
    collaboratedOn: {
        id: "side-navigation.recent-content-menu.filter.collaborated-on",
        defaultMessage: "Collaborated on"
    },
    workedOn: {
        id: "side-navigation.recent-content-menu.filter.worked-on",
        defaultMessage: "Worked on"
    },
    ownedByMe: {
        id: "side-navigation.recent-content-menu.filter.owned-by-me",
        defaultMessage: "Owned by me"
    },
    draftLozengeText: {
        id: "side-navigation.content-menu.lozenge.draft",
        defaultMessage: "DRAFT"
    }
});
function $1195428fc846c248$var$_temp(node_0) {
    return node_0?.object?.content?.status !== "archived";
}
function $1195428fc846c248$var$_temp2(node_1) {
    return node_1?.object?.content?.status !== "trashed";
}
function $1195428fc846c248$var$_temp3(node_2) {
    return node_2?.object?.content?.id;
}
module.exports["useRecentItems"] = $1195428fc846c248$export$bc82a767d3a2a41;
module.exports["useRecentData"] = $1195428fc846c248$export$5b0ada08b9b7bd62;
module.exports["groupNodesIntoSections"] = $1195428fc846c248$export$19e8d4a05b9bbef;
module.exports["useRecentsFilterConfig"] = $1195428fc846c248$export$bf18e6ec9b4e3f2e;

});

parcelRegister("WG1VM", function(module, exports) {
/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");


var $abN8T = parcelRequire("abN8T");


var $d4Pk4 = parcelRequire("d4Pk4");


var $jlIaF = parcelRequire("jlIaF");


var $c7GB4 = parcelRequire("c7GB4");


var $8BHAT = parcelRequire("8BHAT");

const $c69e7b592fedb17e$export$8ec3d08588d2eeda = 30;
var $c69e7b592fedb17e$var$ActivityEventType = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}($c69e7b592fedb17e$var$ActivityEventType || {});
var $c69e7b592fedb17e$var$ActivityObjectType = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivityObjectType["DATABASE"] = "DATABASE";
    ActivityObjectType["EMBED"] = "EMBED";
    ActivityObjectType["CONTENT"] = "CONTENT";
    ActivityObjectType["COMMENT"] = "COMMENT";
    return ActivityObjectType;
}($c69e7b592fedb17e$var$ActivityObjectType || {});
const $c69e7b592fedb17e$export$c49cfb2681596b20 = [
    "PAGE",
    "BLOGPOST",
    "WHITEBOARD",
    "DATABASE",
    "EMBED",
    "CONTENT"
];
const $c69e7b592fedb17e$var$WORKED_ON_EVENT_TYPES = [
    "EDITED",
    "PUBLISHED",
    "UPDATED",
    "CREATED",
    "STARTED",
    "SNAPSHOTTED"
];
const $c69e7b592fedb17e$var$transformActivityNodeLegacyUrl = (activitiesNode)=>{
    const transformedNode = $c69e7b592fedb17e$var$transformActivityData(activitiesNode?.node);
    if (!transformedNode?.object?.content?.links?.webui) return transformedNode;
    return {
        ...transformedNode,
        object: {
            ...transformedNode.object,
            url: `${0, $jlIaF.CONTEXT_PATH}${transformedNode.object.content.links.webui}`,
            content: {
                ...transformedNode.object.content
            }
        }
    };
};
const $c69e7b592fedb17e$var$transformActivityData = (recent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (content) {
        content.type = content.type?.toLowerCase() === 'blog_post' ? 'blogpost' : content.type?.toLowerCase();
        content.subtype = content.subtype?.toLowerCase();
        // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
        // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
        // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
        content.status = [
            content.status,
            content.pageStatus,
            content.blogStatus
        ].find((status)=>status)?.toLowerCase();
        // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
        if (content.status === 'draft' && content.createdAt) content.status = 'current';
    }
    if (recent?.event) recent.event.eventType = recent.event.eventType?.toUpperCase();
    const transformedId = content?.id && (0, $c7GB4.getIdFromConfluenceContentAri)({
        ari: recent?.object?.data?.id,
        resourceType: recent?.object?.data?.type
    });
    const recentData = recent?.object?.data;
    // TODO: This is currently transforming activity V3 data into activity V2 format. This
    // tranformation will be simplified in DISCO-4281
    const transformedContent = {
        ...recentData,
        id: transformedId,
        metadata: {
            ...recentData?.metadata,
            currentuser: {
                favourited: {
                    isFavourite: recentData?.viewer?.favoritedSummary?.isFavorite
                }
            }
        },
        links: {
            webui: recentData?.links?.webUi,
            editui: recentData?.links?.editUi
        },
        subType: recentData?.subtype,
        emoji: {
            nodes: [
                {
                    key: 'emoji-title-published',
                    value: recentData?.metadata?.titleEmojiPublished?.value
                },
                {
                    key: 'emoji-title-draft',
                    value: recentData?.metadata?.titleEmojiDraft?.value
                }
            ]
        }
    };
    return {
        ...recent,
        id: transformedId,
        timestamp: recent?.event?.timestamp,
        object: {
            ...recent?.object,
            content: transformedContent
        }
    };
};
const $c69e7b592fedb17e$var$getAllRecentQueryOptions = (cloudId)=>({
        query: (0, $8BHAT.RecentContentMenuQuery),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda,
            eventTypes: [],
            objectTypes: $c69e7b592fedb17e$export$c49cfb2681596b20
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: (data)=>{
            const allActivity = data?.activity?.myActivity?.all;
            return {
                endCursor: allActivity?.pageInfo?.endCursor || '',
                hasNextPage: allActivity?.pageInfo?.hasNextPage || false
            };
        },
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.activity?.myActivity?.all?.edges || [];
            const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', mergedNodes);
            return result;
        }
    });
const $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions = (cloudId)=>({
        query: (0, $8BHAT.RecentContentMenuQuery),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda,
            eventTypes: $c69e7b592fedb17e$var$WORKED_ON_EVENT_TYPES,
            objectTypes: [
                ...$c69e7b592fedb17e$export$c49cfb2681596b20,
                "COMMENT"
            ]
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: (data)=>{
            const allActivity = data?.activity?.myActivity?.all;
            return {
                endCursor: allActivity?.pageInfo?.endCursor || '',
                hasNextPage: allActivity?.pageInfo?.hasNextPage || false
            };
        },
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.activity?.myActivity?.all?.edges || [];
            const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', mergedNodes);
            return result;
        }
    });
const $c69e7b592fedb17e$var$getWorkedOnQueryOptions = (cloudId)=>({
        query: (0, $8BHAT.RecentContentMenuQuery),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda,
            eventTypes: $c69e7b592fedb17e$var$WORKED_ON_EVENT_TYPES,
            objectTypes: $c69e7b592fedb17e$export$c49cfb2681596b20
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: (data)=>{
            const allActivity = data?.activity?.myActivity?.all;
            return {
                endCursor: allActivity?.pageInfo?.endCursor || '',
                hasNextPage: allActivity?.pageInfo?.hasNextPage || false
            };
        },
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.activity?.myActivity?.all?.edges || [];
            const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', mergedNodes);
            return result;
        }
    });
const $c69e7b592fedb17e$var$mapCreatedByMeTabNodes = (node)=>{
    return {
        ...node,
        timestamp: node?.content?.metadata?.currentuser?.lastcontributed?.when,
        object: {
            url: `${0, $jlIaF.CONTEXT_PATH}${node.url}`,
            content: node.content
        }
    };
};
const $c69e7b592fedb17e$var$getCreatedByMeQueryOptions = ()=>{
    return {
        query: (0, $eSUdr.default)`query recentQueryConfigRecentlyCreatedByMeQuery($cql:String!$cqlcontext:String!$first:Int$after:String){search:confluence_search(cql:$cql cqlcontext:$cqlcontext first:$first after:$after){nodes{url content{id type subType title status space{id name}links{webui editui}metadata{currentuser{favourited{isFavourite favouritedDate}lastcontributed{status when}}}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}space{alias}}}pageInfo{hasNextPage endCursor}}}`,
        initialVars: {
            cql: `type in (page, blogpost, embed, whiteboard, database) and owner=currentUser() and created >= startOfDay("-90d") order by created desc`,
            cqlcontext: `{"contentStatuses":["draft", "current"]}`,
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda
        },
        fetchMoreVars: (endCursor)=>({
                after: endCursor
            }),
        transformNodes: (data)=>(data?.search?.nodes || []).map($c69e7b592fedb17e$var$mapCreatedByMeTabNodes),
        getPaginationParams: (data)=>({
                endCursor: data?.search?.pageInfo?.endCursor || '',
                hasNextPage: data?.search?.pageInfo?.hasNextPage || false
            }),
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.search?.nodes || [];
            const fetchMoreNodes = fetchMoreResult.search?.nodes || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'search.nodes', mergedNodes);
            return result;
        }
    };
};
const $c69e7b592fedb17e$export$175d7f1f999191e6 = (cloudId)=>{
    const queryOptions = {
        ALL: $c69e7b592fedb17e$var$getAllRecentQueryOptions(cloudId),
        COLLABORATED_ON: $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions(cloudId),
        WORKED_ON: $c69e7b592fedb17e$var$getWorkedOnQueryOptions(cloudId),
        CREATED_BY_ME: $c69e7b592fedb17e$var$getCreatedByMeQueryOptions()
    };
    return queryOptions;
};
module.exports["PAGE_SIZE"] = $c69e7b592fedb17e$export$8ec3d08588d2eeda;
module.exports["OBJECT_TYPES"] = $c69e7b592fedb17e$export$c49cfb2681596b20;
module.exports["getQueryOptions"] = $c69e7b592fedb17e$export$175d7f1f999191e6;

});

parcelRegister("1IQhI", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gSytF = parcelRequire("gSytF");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6a9Hv = parcelRequire("6a9Hv");


var $9wEpK = parcelRequire("9wEpK");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6bJyJ = parcelRequire("6bJyJ");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $6F6hl = parcelRequire("6F6hl");


var $jItTa = parcelRequire("jItTa");


var $9x2sR = parcelRequire("9x2sR");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $1YXTQ = parcelRequire("1YXTQ");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");


var $epLE5 = parcelRequire("epLE5");


var $fLinG = parcelRequire("fLinG");


var $6adZX = parcelRequire("6adZX");


var $jFJ1w = parcelRequire("jFJ1w");


var $6qyh6 = parcelRequire("6qyh6");

var $ad49408d40b2cab3$exports = {};
$ad49408d40b2cab3$exports = new URL("emptyStarBox.3b01bf42.svg", import.meta.url).toString();



var $lg4wi = parcelRequire("lg4wi");


var $1NAW6 = parcelRequire("1NAW6");


var $asFJu = parcelRequire("asFJu");


var $26Pni = parcelRequire("26Pni");


const $7e963e12da3cafa7$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await Promise.resolve((parcelRequire("6y3LW")))).fireContentMenuItemClickedAnalytics);
const $7e963e12da3cafa7$export$5eb56a319167fc22 = (0, $gSytF.default);
const $7e963e12da3cafa7$export$776b5788fd07993d = {
    start: 0
};
const $7e963e12da3cafa7$export$451cf4cf29a89606 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e963e12da3cafa7$export$acc22f9f46590959, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e963e12da3cafa7$export$8a612803f04f2e92, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $7e963e12da3cafa7$export$8a612803f04f2e92 = ()=>{
    const $ = (0, $frIzR.c)(54);
    const intl = (0, $8C5kA.default)();
    const [filterText, setFilterText] = (0, $42omo.useState)("");
    const scrollableRef = (0, $42omo.useRef)(null);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            variables: $7e963e12da3cafa7$export$776b5788fd07993d,
            fetchPolicy: "cache-and-network"
        };
        $[0] = t0;
    } else t0 = $[0];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, networkStatus: networkStatus } = (0, $jMyy4.useQueryInterop)($7e963e12da3cafa7$export$5eb56a319167fc22, t0);
    const hasNextPage = data?.favoriteContent?.pageInfo?.hasNextPage || false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    let t1;
    if ($[1] !== data?.favoriteContent?.nodes || $[2] !== filterText) {
        const lowerFilterText = filterText.toLowerCase();
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(data?.favoriteContent?.nodes?.filter((content)=>content !== null && content !== undefined && (!filterText || (content.title?.toLowerCase() || "").includes(lowerFilterText))), $7e963e12da3cafa7$var$_temp);
        $[1] = data?.favoriteContent?.nodes;
        $[2] = filterText;
        $[3] = t1;
    } else t1 = $[3];
    const filteredContent = t1;
    let t2;
    if ($[4] !== data?.favoriteContent?.nodes?.length || $[5] !== fetchMore || $[6] !== networkStatus) {
        t2 = ()=>{
            if (networkStatus === (0, $9wEpK.NetworkStatus).ready) (0, $26Pni.fetchMoreStarredContent)(fetchMore, data?.favoriteContent?.nodes?.length || 0);
        };
        $[4] = data?.favoriteContent?.nodes?.length;
        $[5] = fetchMore;
        $[6] = networkStatus;
        $[7] = t2;
    } else t2 = $[7];
    data?.favoriteContent?.nodes;
    const loadMore = t2;
    const isEmptyState = !filterText && !filteredContent?.length;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            componentType: "fixedItem",
            itemId: "viewAllStarredItems"
        };
        $[8] = t3;
    } else t3 = $[8];
    const fireClickAnalytics = $7e963e12da3cafa7$var$useLazyClickAnalytics(createAnalyticsEvent, "starredNavigationMenuItem", t3);
    let t4;
    if ($[9] !== closeFlyout || $[10] !== fireClickAnalytics) {
        t4 = ()=>{
            closeFlyout();
            fireClickAnalytics();
        };
        $[9] = closeFlyout;
        $[10] = fireClickAnalytics;
        $[11] = t4;
    } else t4 = $[11];
    const onClick = t4;
    let t5;
    if ($[12] !== hasNextPage || $[13] !== loadMore) {
        t5 = {
            hasNextPage: hasNextPage,
            scrollableRef: scrollableRef,
            loadMore: loadMore
        };
        $[12] = hasNextPage;
        $[13] = loadMore;
        $[14] = t5;
    } else t5 = $[14];
    const { showLoadMoreButton: showLoadMoreButton, setShowLoadMoreButton: setShowLoadMoreButton, loadMoreButtonRef: loadMoreButtonRef, handleKeyDown: handleKeyDown, handleBlurCapture: handleBlurCapture, handleLoadMoreButtonClick: handleLoadMoreButtonClick } = (0, $asFJu.useInfiniteScroll)(t5);
    let t6;
    if ($[15] !== setShowLoadMoreButton) {
        t6 = (text)=>{
            setFilterText(text);
            setShowLoadMoreButton(false);
        };
        $[15] = setShowLoadMoreButton;
        $[16] = t6;
    } else t6 = $[16];
    const onFilterTextChange = t6;
    let t7;
    if ($[17] !== intl) {
        t7 = intl.formatMessage($7e963e12da3cafa7$var$i18n.title);
        $[17] = intl;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== data || $[20] !== filterText || $[21] !== intl || $[22] !== isEmptyState || $[23] !== loading || $[24] !== onFilterTextChange) {
        t8 = !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.075",
            paddingInlineStart: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NAW6.ContentMenuTextFilter), {
            filterText: filterText,
            setFilterText: onFilterTextChange,
            placeholder: intl.formatMessage($7e963e12da3cafa7$var$i18n.filterPlaceholder),
            isDisabled: loading && !data,
            actionSubjectId: "starredNavigationMenuItem",
            itemId: "filterStarredItems"
        }));
        $[19] = data;
        $[20] = filterText;
        $[21] = intl;
        $[22] = isEmptyState;
        $[23] = loading;
        $[24] = onFilterTextChange;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== data || $[27] !== error || $[28] !== filterText || $[29] !== filteredContent || $[30] !== loading) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e963e12da3cafa7$var$StarredContentMenuInner, {
            error: error,
            loading: loading,
            data: data,
            filteredContent: filteredContent,
            filterText: filterText
        });
        $[26] = data;
        $[27] = error;
        $[28] = filterText;
        $[29] = filteredContent;
        $[30] = loading;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== data?.favoriteContent?.nodes?.length || $[33] !== handleLoadMoreButtonClick || $[34] !== hasNextPage || $[35] !== isEmptyState || $[36] !== loadMore || $[37] !== loadMoreButtonRef || $[38] !== showLoadMoreButton) {
        t10 = !isEmptyState && hasNextPage && data?.favoriteContent?.nodes?.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "starred-content-menu-load-more"
        }, showLoadMoreButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ref: loadMoreButtonRef,
            shouldFitContainer: true,
            onClick: handleLoadMoreButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $7e963e12da3cafa7$var$i18n.loadMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLinG.ViewportObserver), {
            onViewportEnter: loadMore
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadMoreState), null)));
        $[32] = data?.favoriteContent?.nodes?.length;
        $[33] = handleLoadMoreButtonClick;
        $[34] = hasNextPage;
        $[35] = isEmptyState;
        $[36] = loadMore;
        $[37] = loadMoreButtonRef;
        $[38] = showLoadMoreButton;
        $[39] = t10;
    } else t10 = $[39];
    let t11;
    if ($[40] !== handleBlurCapture || $[41] !== handleKeyDown || $[42] !== t10 || $[43] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7e963e12da3cafa7$var$overflowStyles,
            ref: scrollableRef,
            onKeyDown: handleKeyDown,
            onBlurCapture: handleBlurCapture
        }, t9, t10);
        $[40] = handleBlurCapture;
        $[41] = handleKeyDown;
        $[42] = t10;
        $[43] = t9;
        $[44] = t11;
    } else t11 = $[44];
    let t12;
    if ($[45] !== intl || $[46] !== isEmptyState || $[47] !== onClick) {
        t12 = !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jItTa.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: (0, $1NBp8.HOME).toUrl({
                view: "starred"
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onClick
        }, intl.formatMessage($7e963e12da3cafa7$var$i18n.viewAll)));
        $[45] = intl;
        $[46] = isEmptyState;
        $[47] = onClick;
        $[48] = t12;
    } else t12 = $[48];
    let t13;
    if ($[49] !== t11 || $[50] !== t12 || $[51] !== t7 || $[52] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFJ1w.ContentMenu), {
            title: t7
        }, t8, t11, t12);
        $[49] = t11;
        $[50] = t12;
        $[51] = t7;
        $[52] = t8;
        $[53] = t13;
    } else t13 = $[53];
    return t13;
};
const $7e963e12da3cafa7$export$acc22f9f46590959 = ()=>{
    const $ = (0, $frIzR.c)(48);
    const intl = (0, $8C5kA.default)();
    const [filterText, setFilterText] = (0, $42omo.useState)("");
    const scrollableRef = (0, $42omo.useRef)(null);
    let t0;
    if ($[0] !== filterText) {
        t0 = {
            searchText: filterText
        };
        $[0] = filterText;
        $[1] = t0;
    } else t0 = $[1];
    const platformData = (0, $26Pni.useStarredData)(t0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const isEmptyState = !filterText && !platformData.filteredNodes?.length;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            componentType: "fixedItem",
            itemId: "viewAllStarredItems"
        };
        $[2] = t1;
    } else t1 = $[2];
    const fireClickAnalytics = $7e963e12da3cafa7$var$useLazyClickAnalytics(createAnalyticsEvent, "starredNavigationMenuItem", t1);
    let t2;
    if ($[3] !== closeFlyout || $[4] !== fireClickAnalytics) {
        t2 = ()=>{
            closeFlyout();
            fireClickAnalytics();
        };
        $[3] = closeFlyout;
        $[4] = fireClickAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    const onClick = t2;
    let t3;
    if ($[6] !== platformData.hasNextPage || $[7] !== platformData.loadMore) {
        t3 = {
            hasNextPage: platformData.hasNextPage,
            scrollableRef: scrollableRef,
            loadMore: platformData.loadMore
        };
        $[6] = platformData.hasNextPage;
        $[7] = platformData.loadMore;
        $[8] = t3;
    } else t3 = $[8];
    const { showLoadMoreButton: showLoadMoreButton, setShowLoadMoreButton: setShowLoadMoreButton, loadMoreButtonRef: loadMoreButtonRef, handleKeyDown: handleKeyDown, handleBlurCapture: handleBlurCapture, handleLoadMoreButtonClick: handleLoadMoreButtonClick } = (0, $asFJu.useInfiniteScroll)(t3);
    let t4;
    if ($[9] !== setShowLoadMoreButton) {
        t4 = (text)=>{
            setFilterText(text);
            setShowLoadMoreButton(false);
        };
        $[9] = setShowLoadMoreButton;
        $[10] = t4;
    } else t4 = $[10];
    const onFilterTextChange = t4;
    let t5;
    if ($[11] !== intl) {
        t5 = intl.formatMessage($7e963e12da3cafa7$var$i18n.title);
        $[11] = intl;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== filterText || $[14] !== intl || $[15] !== isEmptyState || $[16] !== onFilterTextChange || $[17] !== platformData.data || $[18] !== platformData.loading) {
        t6 = !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.075",
            paddingInlineStart: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NAW6.ContentMenuTextFilter), {
            filterText: filterText,
            setFilterText: onFilterTextChange,
            placeholder: intl.formatMessage($7e963e12da3cafa7$var$i18n.filterPlaceholder),
            isDisabled: platformData.loading && !platformData.data,
            actionSubjectId: "starredNavigationMenuItem",
            itemId: "filterStarredItems"
        }));
        $[13] = filterText;
        $[14] = intl;
        $[15] = isEmptyState;
        $[16] = onFilterTextChange;
        $[17] = platformData.data;
        $[18] = platformData.loading;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== filterText || $[21] !== platformData.data || $[22] !== platformData.error || $[23] !== platformData.filteredNodes || $[24] !== platformData.loading) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e963e12da3cafa7$var$StarredContentMenuInner, {
            error: platformData.error,
            loading: platformData.loading,
            data: platformData.data,
            filteredContent: platformData.filteredNodes,
            filterText: filterText
        });
        $[20] = filterText;
        $[21] = platformData.data;
        $[22] = platformData.error;
        $[23] = platformData.filteredNodes;
        $[24] = platformData.loading;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== handleLoadMoreButtonClick || $[27] !== isEmptyState || $[28] !== loadMoreButtonRef || $[29] !== platformData.data?.favoriteContent?.nodes?.length || $[30] !== platformData.hasNextPage || $[31] !== platformData.loadMore || $[32] !== showLoadMoreButton) {
        t8 = !isEmptyState && platformData.hasNextPage && platformData.data?.favoriteContent?.nodes?.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "starred-content-menu-load-more"
        }, showLoadMoreButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ref: loadMoreButtonRef,
            shouldFitContainer: true,
            onClick: handleLoadMoreButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $7e963e12da3cafa7$var$i18n.loadMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLinG.ViewportObserver), {
            onViewportEnter: platformData.loadMore
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadMoreState), null)));
        $[26] = handleLoadMoreButtonClick;
        $[27] = isEmptyState;
        $[28] = loadMoreButtonRef;
        $[29] = platformData.data?.favoriteContent?.nodes?.length;
        $[30] = platformData.hasNextPage;
        $[31] = platformData.loadMore;
        $[32] = showLoadMoreButton;
        $[33] = t8;
    } else t8 = $[33];
    let t9;
    if ($[34] !== handleBlurCapture || $[35] !== handleKeyDown || $[36] !== t7 || $[37] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7e963e12da3cafa7$var$overflowStyles,
            ref: scrollableRef,
            onKeyDown: handleKeyDown,
            onBlurCapture: handleBlurCapture
        }, t7, t8);
        $[34] = handleBlurCapture;
        $[35] = handleKeyDown;
        $[36] = t7;
        $[37] = t8;
        $[38] = t9;
    } else t9 = $[38];
    let t10;
    if ($[39] !== intl || $[40] !== isEmptyState || $[41] !== onClick) {
        t10 = !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jItTa.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: (0, $1NBp8.HOME).toUrl({
                view: "starred"
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onClick
        }, intl.formatMessage($7e963e12da3cafa7$var$i18n.viewAll)));
        $[39] = intl;
        $[40] = isEmptyState;
        $[41] = onClick;
        $[42] = t10;
    } else t10 = $[42];
    let t11;
    if ($[43] !== t10 || $[44] !== t5 || $[45] !== t6 || $[46] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFJ1w.ContentMenu), {
            title: t5
        }, t6, t9, t10);
        $[43] = t10;
        $[44] = t5;
        $[45] = t6;
        $[46] = t9;
        $[47] = t11;
    } else t11 = $[47];
    return t11;
};
const $7e963e12da3cafa7$var$StarredContentMenuInner = (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { error: error, loading: loading, data: data, filteredContent: filteredContent, filterText: filterText } = t0;
    const intl = (0, $8C5kA.default)();
    if (error) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage($7e963e12da3cafa7$var$i18n.errorMessageTitle);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuErrorState), {
                errorTitle: t1
            });
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                navVersion: "4",
                dropdownType: "starred"
            };
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== error) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                error: error,
                attributes: t3
            });
            $[5] = error;
            $[6] = t4;
        } else t4 = $[6];
        let t5;
        if ($[7] !== t2 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t4);
            $[7] = t2;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    if (loading && !data) {
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadingState), null);
            $[10] = t1;
        } else t1 = $[10];
        return t1;
    }
    if (!filteredContent || filteredContent?.length === 0) {
        let t1;
        if ($[11] !== filterText || $[12] !== intl) {
            t1 = filterText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuNoResultsState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuEmptyState), {
                image: (0, (/*@__PURE__*/$parcel$interopDefault($ad49408d40b2cab3$exports))),
                title: intl.formatMessage($7e963e12da3cafa7$var$i18n.emptyStateTitle),
                message: intl.formatMessage($7e963e12da3cafa7$var$i18n.emptyStateMessage)
            });
            $[11] = filterText;
            $[12] = intl;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    let t1;
    if ($[14] !== filterText || $[15] !== filteredContent.length || $[16] !== intl) {
        t1 = filterText !== "" ? intl.formatMessage($7e963e12da3cafa7$var$i18n.filteredResultsCount, {
            count: filteredContent.length
        }) : intl.formatMessage($7e963e12da3cafa7$var$i18n.showingAllResults);
        $[14] = filterText;
        $[15] = filteredContent.length;
        $[16] = intl;
        $[17] = t1;
    } else t1 = $[17];
    let t2;
    if ($[18] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            role: "status"
        }, t1);
        $[18] = t1;
        $[19] = t2;
    } else t2 = $[19];
    let t3;
    if ($[20] !== filteredContent || $[21] !== intl) {
        let t4;
        if ($[23] !== intl) {
            t4 = (content)=>content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6qyh6.ContentMenuItem), {
                    key: content.id,
                    content: content,
                    actionSubjectId: "starredNavigationMenuItem",
                    timestamp: content.metadata.currentuser?.favourited?.favouritedDate ? (0, $1YXTQ.formatTimeAgo)(intl, content.metadata.currentuser?.favourited?.favouritedDate) : undefined
                }) : null;
            $[23] = intl;
            $[24] = t4;
        } else t4 = $[24];
        t3 = filteredContent.map(t4);
        $[20] = filteredContent;
        $[21] = intl;
        $[22] = t3;
    } else t3 = $[22];
    let t4;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            attributes: {
                navVersion: "4",
                dropdownType: "starred"
            }
        });
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== t2 || $[27] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t3, t4);
        $[26] = t2;
        $[27] = t3;
        $[28] = t5;
    } else t5 = $[28];
    return t5;
};
const $7e963e12da3cafa7$var$overflowStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: '100%',
    justifyContent: 'start',
    marginInline: 'space.negative.100',
    paddingInline: 'space.100',
    paddingBlockEnd: 'space.050',
    //@ts-expect-error styling is applying but property does not exist for SafeCSSObject
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    a: {
        ':focus-visible': {
            outlineOffset: `${"var(--ds-space-negative-025, -2px)"}`
        }
    }
});
const $7e963e12da3cafa7$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "side-navigation.starred-content-menu.title",
        defaultMessage: "Starred"
    },
    filterPlaceholder: {
        id: "side-navigation.starred-content-menu.filter-placeholder",
        defaultMessage: "Filter starred items"
    },
    viewAll: {
        id: "side-navigation.starred-content-menu.view-all",
        defaultMessage: "View all starred items"
    },
    emptyStateTitle: {
        id: "side-navigation.starred-content-menu.empty-state-title",
        defaultMessage: "You haven\u2019t starred anything yet"
    },
    emptyStateMessage: {
        id: "side-navigation.starred-content-menu.empty-state-message",
        defaultMessage: "Mark items that are important to you with a star to quickly access them. You\u2019ll see those items here."
    },
    errorMessageTitle: {
        id: "side-navigation.starred-content-menu.error-message.title",
        defaultMessage: "We couldn\u2019t load your starred items"
    },
    loadMore: {
        id: "side-navigation.starred-content-menu.load-more",
        defaultMessage: "Load more"
    },
    filteredResultsCount: {
        id: "side-navigation.star-content-menu.filtered-results-announcement",
        defaultMessage: "{count, plural, one {# result} other {# results}} found"
    },
    showingAllResults: {
        id: "side-navigation.star-content-menu.all-results-announcement",
        defaultMessage: "Showing all starred pages"
    }
});
function $7e963e12da3cafa7$var$_temp(content_0) {
    return content_0?.id;
}
module.exports["StarredContentMenuQuery"] = $7e963e12da3cafa7$export$5eb56a319167fc22;
module.exports["starredContentMenuQueryVars"] = $7e963e12da3cafa7$export$776b5788fd07993d;
module.exports["StarredContentMenu"] = $7e963e12da3cafa7$export$451cf4cf29a89606;
module.exports["StarredContentMenuPlatform"] = $7e963e12da3cafa7$export$acc22f9f46590959;
module.exports["StarredContentMenuGlobal"] = $7e963e12da3cafa7$export$8a612803f04f2e92;

});

parcelRegister("jFJ1w", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $cO1el = parcelRequire("cO1el");

const $74a973700eebe7fc$export$a7eb5ad3a73e575f = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { title: title, children: children } = t0;
    let t1;
    if ($[0] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $74a973700eebe7fc$var$headingStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "h2",
            size: "xsmall"
        }, title));
        $[0] = title;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $74a973700eebe7fc$var$containerStyles
        }, t1, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $74a973700eebe7fc$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxHeight: 'min(calc(100vh - 26px), 760px)'
});
const $74a973700eebe7fc$var$headingStyles = (0, $ecnYn.xcss)({
    height: 'size.300',
    paddingBlock: 'space.075',
    paddingLeft: 'space.075',
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    display: 'flex',
    alignItems: 'center'
});
module.exports["ContentMenu"] = $74a973700eebe7fc$export$a7eb5ad3a73e575f;

});

parcelRegister("6qyh6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $5nBzc = parcelRequire("5nBzc");


var $9x2sR = parcelRequire("9x2sR");


var $eFm27 = parcelRequire("eFm27");


var $jlIaF = parcelRequire("jlIaF");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");


var $bCECL = parcelRequire("bCECL");


var $epLE5 = parcelRequire("epLE5");


var $9wGTI = parcelRequire("9wGTI");


var $6adZX = parcelRequire("6adZX");


const $9de18fa36277a442$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await Promise.resolve((parcelRequire("6y3LW")))).fireContentMenuItemClickedAnalytics);
const $9de18fa36277a442$export$b44c5cc9e992fdfc = (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { content: content, actionSubjectId: actionSubjectId, url: url, section: section, selectedFilter: selectedFilter, timestamp: timestamp, hideStarButton: hideStarButton } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { id: id, type: type, links: links, space: space, metadata: metadata } = content;
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const t1 = content?.status;
    let t2;
    if ($[0] !== id || $[1] !== section || $[2] !== selectedFilter || $[3] !== t1 || $[4] !== type) {
        t2 = {
            componentType: "customItem",
            contentType: type,
            contentId: id,
            contentStatus: t1,
            section: section,
            selectedFilter: selectedFilter
        };
        $[0] = id;
        $[1] = section;
        $[2] = selectedFilter;
        $[3] = t1;
        $[4] = type;
        $[5] = t2;
    } else t2 = $[5];
    const fireClickItemAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t2);
    let t3;
    if ($[6] !== id || $[7] !== type) {
        t3 = {
            componentType: "customItemAction",
            itemId: "star",
            parentContentType: type,
            parentContentId: id
        };
        $[6] = id;
        $[7] = type;
        $[8] = t3;
    } else t3 = $[8];
    const fireStarClickAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t3);
    let t4;
    if ($[9] !== id || $[10] !== type) {
        t4 = {
            componentType: "customItemAction",
            itemId: "unstar",
            parentContentType: type,
            parentContentId: id
        };
        $[9] = id;
        $[10] = type;
        $[11] = t4;
    } else t4 = $[11];
    const fireUnstarClickAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t4);
    let t5;
    if ($[12] !== closeFlyout || $[13] !== fireClickItemAnalytics) {
        t5 = ()=>{
            closeFlyout();
            fireClickItemAnalytics();
        };
        $[12] = closeFlyout;
        $[13] = fireClickItemAnalytics;
        $[14] = t5;
    } else t5 = $[14];
    const onClick = t5;
    if (!id) return null;
    const isStarred = metadata?.currentuser?.favourited?.isFavourite || false;
    const description = timestamp ? `${space?.name} \xb7 ${timestamp}` : space?.name;
    const link = url || `${0, $jlIaF.CONTEXT_PATH}${links?.webui}`;
    let t6;
    if ($[15] !== content.type) {
        t6 = content?.type && (content?.type != "whiteboard" || (0, $9wGTI.fg)("confluence_frontend_whiteboard_emoji_titles"));
        $[15] = content.type;
        $[16] = t6;
    } else t6 = $[16];
    const isEmojiContentType = t6;
    let emoji;
    let t7;
    if ($[17] !== content || $[18] !== isEmojiContentType) {
        const { emoji: t8, hasEmojiProperty: t9 } = isEmojiContentType ? $9de18fa36277a442$var$getEmoji(content) : {};
        emoji = t8 === undefined ? undefined : t8;
        const hasEmojiProperty = t9 === undefined ? undefined : t9;
        t7 = isEmojiContentType ? $9de18fa36277a442$var$getTitle(content?.title, hasEmojiProperty) : content?.title;
        $[17] = content;
        $[18] = isEmojiContentType;
        $[19] = emoji;
        $[20] = t7;
    } else {
        emoji = $[19];
        t7 = $[20];
    }
    const title = t7;
    const isDraft = content?.status === "draft";
    let t8;
    if ($[21] !== fireStarClickAnalytics || $[22] !== fireUnstarClickAnalytics || $[23] !== id || $[24] !== isStarred) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eFm27.PageStarButton), {
            contentId: id,
            isStarred: isStarred,
            size: "small",
            tooltipPosition: "top",
            onStar: fireStarClickAnalytics,
            onUnstar: fireUnstarClickAnalytics,
            spacing: "none"
        });
        $[21] = fireStarClickAnalytics;
        $[22] = fireUnstarClickAnalytics;
        $[23] = id;
        $[24] = isStarred;
        $[25] = t8;
    } else t8 = $[25];
    const starButton = t8;
    let t9;
    if ($[26] !== content.subType || $[27] !== emoji || $[28] !== type) {
        t9 = type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: type,
            emoji: emoji,
            subType: content?.subType
        });
        $[26] = content.subType;
        $[27] = emoji;
        $[28] = type;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== isDraft) {
        t10 = isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9de18fa36277a442$var$i18n.draftLozengeText));
        $[30] = isDraft;
        $[31] = t10;
    } else t10 = $[31];
    const t11 = !hideStarButton && isStarred ? starButton : undefined;
    const t12 = !hideStarButton && !isStarred ? starButton : undefined;
    const t13 = description || "";
    let t14;
    if ($[32] !== title) {
        t14 = title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9de18fa36277a442$var$i18n.untitled);
        $[32] = title;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== link || $[35] !== onClick || $[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t14 || $[41] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            elemBefore: t9,
            elemAfter: t10,
            actions: t11,
            actionsOnHover: t12,
            href: link,
            description: t13,
            onClick: onClick
        }, t14);
        $[34] = link;
        $[35] = onClick;
        $[36] = t10;
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
        $[40] = t14;
        $[41] = t9;
        $[42] = t15;
    } else t15 = $[42];
    return t15;
};
const $9de18fa36277a442$var$getEmoji = (content)=>{
    const emojiPropertyPublished = (0, $8rneB.getEmojiPublishedFromProperties)(content);
    const emojiPropertyDraft = (0, $8rneB.getEmojiDraftFromProperties)(content);
    const emoji = emojiPropertyPublished || emojiPropertyDraft || (0, $brn6e.getEmojiFromTitle)(content.title);
    return {
        hasEmojiProperty: Boolean(emojiPropertyPublished || emojiPropertyDraft),
        emoji: emoji
    };
};
const $9de18fa36277a442$var$getTitle = (originalTitle, hasEmojiProperty)=>hasEmojiProperty ? originalTitle : (0, $brn6e.removeEmojiFromTitle)(originalTitle);
const $9de18fa36277a442$var$i18n = (0, $cgtv4.defineMessages)({
    untitled: {
        id: "side-navigation.content-menu.untitled",
        defaultMessage: "Untitled"
    },
    draftLozengeText: {
        id: "side-navigation.content-menu.lozenge.draft",
        defaultMessage: "DRAFT"
    }
});
module.exports["ContentMenuItem"] = $9de18fa36277a442$export$b44c5cc9e992fdfc;

});

parcelRegister("lg4wi", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $gj7hi = parcelRequire("gj7hi");


var $kpYGL = parcelRequire("kpYGL");

var $5a97534dd007005d$exports = {};
$5a97534dd007005d$exports = new URL("errorWarning.3a015e54.svg", import.meta.url).toString();


var $df12eff91c81157e$exports = {};
$df12eff91c81157e$exports = new URL("noResultsDark.90199792.svg", import.meta.url).toString();


var $bc2576083d9a2d49$exports = {};
$bc2576083d9a2d49$exports = new URL("noResultsLight.5ffcf568.svg", import.meta.url).toString();


const $4fca70a5a203ab8a$var$ImageWithText = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { image: image, message: message, title: title, darkImage: darkImage, linkElement: linkElement } = t0;
    const t1 = darkImage || "";
    let t2;
    if ($[0] !== image || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: image,
            srcDark: t1,
            alt: "",
            width: "160px",
            height: "160px"
        });
        $[0] = image;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== title) {
        t3 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "bold",
            color: "color.text.subtle"
        }, title);
        $[3] = title;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== message) {
        t4 = message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle",
            align: "center",
            css: {
                textWrap: "balance"
            }
        }, message);
        $[5] = message;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== linkElement) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small"
        }, linkElement);
        $[7] = linkElement;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            alignInline: "center",
            space: "space.100"
        }, t3, t4, t5);
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t2 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            alignInline: "center",
            space: "space.100",
            grow: "fill"
        }, t2, t6);
        $[13] = t2;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
};
const $4fca70a5a203ab8a$export$ee5f7ba6ec666d35 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { errorTitle: errorTitle } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($4fca70a5a203ab8a$var$i18n.errorMessageSubtitle);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== errorTitle || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($5a97534dd007005d$exports))),
            title: errorTitle,
            message: t1
        });
        $[2] = errorTitle;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $4fca70a5a203ab8a$export$5967fd5ff661574a = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { message: message, advancedSearchLink: advancedSearchLink } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== intl || $[1] !== message) {
        t1 = message || intl.formatMessage($4fca70a5a203ab8a$var$i18n.noResultsMessageSubtitle);
        $[0] = intl;
        $[1] = message;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== advancedSearchLink || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockStart: "space.800",
            paddingBlockEnd: "space.300",
            paddingInline: "space.800"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($bc2576083d9a2d49$exports))),
            message: t1,
            darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($df12eff91c81157e$exports))),
            linkElement: advancedSearchLink
        }));
        $[3] = advancedSearchLink;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $4fca70a5a203ab8a$export$f6bcb1c900d8bf76 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { image: image, title: title, message: message, linkElement: linkElement } = t0;
    let t1;
    if ($[0] !== image || $[1] !== linkElement || $[2] !== message || $[3] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.800"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
            image: image,
            title: title,
            message: message,
            linkElement: linkElement
        }));
        $[0] = image;
        $[1] = linkElement;
        $[2] = message;
        $[3] = title;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
const $4fca70a5a203ab8a$var$skeletonProps = {
    height: '9px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    isShimmering: true,
    color: "var(--ds-skeleton, #0515240F)",
    ShimmeringEndColor: "var(--ds-skeleton-subtle, #17171708)"
};
const $4fca70a5a203ab8a$export$a2ec9fdcdf0bd301 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.300",
            alignBlock: "center",
            alignInline: "center",
            grow: "fill",
            testId: "content-menu-loading"
        }, [
            ...Array(10)
        ].map($4fca70a5a203ab8a$var$_temp)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $4fca70a5a203ab8a$export$feed0f481420fd40 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.300",
            grow: "fill",
            testId: "content-menu-load-more"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "180px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "140px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "180px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "140px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $4fca70a5a203ab8a$var$i18n = (0, $cgtv4.defineMessages)({
    errorMessageSubtitle: {
        id: "side-navigation.content-menu.error-message.subtitle",
        defaultMessage: "Refresh and try again."
    },
    noResultsMessageSubtitle: {
        id: "side-navigation.content-menu.no-results-message.subtitle",
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for."
    }
});
function $4fca70a5a203ab8a$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        key: index,
        width: "250px",
        ...$4fca70a5a203ab8a$var$skeletonProps
    });
}
module.exports["ContentMenuErrorState"] = $4fca70a5a203ab8a$export$ee5f7ba6ec666d35;
module.exports["ContentMenuNoResultsState"] = $4fca70a5a203ab8a$export$5967fd5ff661574a;
module.exports["ContentMenuEmptyState"] = $4fca70a5a203ab8a$export$f6bcb1c900d8bf76;
module.exports["ContentMenuLoadingState"] = $4fca70a5a203ab8a$export$a2ec9fdcdf0bd301;
module.exports["ContentMenuLoadMoreState"] = $4fca70a5a203ab8a$export$feed0f481420fd40;

});

parcelRegister("1NAW6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $gdv5Z = parcelRequire("gdv5Z");


var $jluld = parcelRequire("jluld");


var $hmuev = parcelRequire("hmuev");


var $4noo5 = parcelRequire("4noo5");


var $inPa6 = parcelRequire("inPa6");


var $epLE5 = parcelRequire("epLE5");


const $ba4ff569986cbcbe$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await Promise.resolve((parcelRequire("6y3LW")))).fireContentMenuItemClickedAnalytics);
const $ba4ff569986cbcbe$var$textFieldStyles = null;
const $ba4ff569986cbcbe$export$efb95505bdfcf1ee = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { filterText: filterText, setFilterText: setFilterText, placeholder: placeholder, isDisabled: isDisabled, actionSubjectId: actionSubjectId, itemId: itemId } = t0;
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== itemId) {
        t1 = {
            componentType: "fixedItem",
            itemId: itemId
        };
        $[0] = itemId;
        $[1] = t1;
    } else t1 = $[1];
    const fireClickAnalytics = $ba4ff569986cbcbe$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t1);
    const setFilterFieldRef = $ba4ff569986cbcbe$var$_temp;
    let t2;
    if ($[2] !== setFilterText) {
        t2 = (e)=>setFilterText(e.currentTarget.value);
        $[2] = setFilterText;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: "",
            color: "currentColor"
        }));
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== filterText || $[6] !== intl || $[7] !== setFilterText) {
        t4 = Boolean(filterText) && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            paddingInlineEnd: "space.050"
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: intl.formatMessage($ba4ff569986cbcbe$var$i18n.clearFilter),
            onClick: ()=>setFilterText("")
        }));
        $[5] = filterText;
        $[6] = intl;
        $[7] = setFilterText;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_1h6d1l7x"
        ]);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== filterText || $[11] !== fireClickAnalytics || $[12] !== isDisabled || $[13] !== placeholder || $[14] !== t2 || $[15] !== t4) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $4noo5.default), {
            ref: setFilterFieldRef,
            value: filterText,
            onChange: t2,
            onMouseDown: fireClickAnalytics,
            elemBeforeInput: t3,
            elemAfterInput: t4,
            isCompact: true,
            placeholder: placeholder,
            isDisabled: isDisabled,
            "aria-label": placeholder,
            className: t5
        });
        $[10] = filterText;
        $[11] = fireClickAnalytics;
        $[12] = isDisabled;
        $[13] = placeholder;
        $[14] = t2;
        $[15] = t4;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};
const $ba4ff569986cbcbe$var$i18n = (0, $cgtv4.defineMessages)({
    clearFilter: {
        id: "side-navigation.content-menu.text-filter.clear-filter",
        defaultMessage: "Clear filter"
    }
});
function $ba4ff569986cbcbe$var$_temp(node) {
    if (node) node.focus();
}
module.exports["ContentMenuTextFilter"] = $ba4ff569986cbcbe$export$efb95505bdfcf1ee;

});

parcelRegister("asFJu", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $208062d54eade01a$export$a973cef5093a8d22 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { hasNextPage: hasNextPage, scrollableRef: scrollableRef, loadMore: loadMore } = t0;
    const [showLoadMoreButton, setShowLoadMoreButton] = (0, $42omo.useState)(false);
    const isTabbedRef = (0, $42omo.useRef)(false);
    const loadMoreButtonRef = (0, $42omo.useRef)(null);
    const lastItemRef = (0, $42omo.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setShowLoadMoreButton(false);
        };
        $[0] = t1;
    } else t1 = $[0];
    const hideLoadMoreButton = t1;
    let t2;
    let t3;
    if ($[1] !== scrollableRef) {
        t2 = ()=>{
            const scrollableElement = scrollableRef.current;
            scrollableElement?.addEventListener("wheel", hideLoadMoreButton);
            return ()=>{
                scrollableElement?.removeEventListener("wheel", hideLoadMoreButton);
            };
        };
        t3 = [
            hideLoadMoreButton,
            scrollableRef
        ];
        $[1] = scrollableRef;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[4] !== loadMore) {
        t4 = ()=>{
            lastItemRef.current?.focus();
            setShowLoadMoreButton(false);
            loadMore();
        };
        $[4] = loadMore;
        $[5] = t4;
    } else t4 = $[5];
    const handleLoadMoreButtonClick = t4;
    let t5;
    if ($[6] !== hasNextPage) {
        t5 = (event)=>{
            isTabbedRef.current = event.key === "Tab" && !event.shiftKey;
            if (isTabbedRef.current && hasNextPage) setShowLoadMoreButton(true);
        };
        $[6] = hasNextPage;
        $[7] = t5;
    } else t5 = $[7];
    const handleKeyDown = t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (event_0)=>{
            const { target: blurredElement, relatedTarget: nextFocusedElement } = event_0;
            if (nextFocusedElement === loadMoreButtonRef.current) lastItemRef.current = blurredElement;
        };
        $[8] = t6;
    } else t6 = $[8];
    const handleBlurCapture = t6;
    let t7;
    if ($[9] !== handleKeyDown || $[10] !== handleLoadMoreButtonClick || $[11] !== loadMore || $[12] !== showLoadMoreButton) {
        t7 = {
            showLoadMoreButton: showLoadMoreButton,
            setShowLoadMoreButton: setShowLoadMoreButton,
            loadMoreButtonRef: loadMoreButtonRef,
            handleKeyDown: handleKeyDown,
            handleBlurCapture: handleBlurCapture,
            handleLoadMoreButtonClick: handleLoadMoreButtonClick,
            loadMore: loadMore
        };
        $[9] = handleKeyDown;
        $[10] = handleLoadMoreButtonClick;
        $[11] = loadMore;
        $[12] = showLoadMoreButton;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
module.exports["useInfiniteScroll"] = $208062d54eade01a$export$a973cef5093a8d22;

});

parcelRegister("6y3LW", function(module, exports) {
const $aac5b14b108aa083$export$744f6d2ef9fc49d7 = (createAnalyticsEvent, actionSubjectId, options)=>()=>{
        const { componentType: componentType, itemId: itemId, contentType: contentType, contentId: contentId, contentStatus: contentStatus, section: section, selectedFilter: selectedFilter, parentContentType: parentContentType, parentContentId: parentContentId } = options;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: actionSubjectId,
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: componentType,
                    itemId: itemId,
                    contentType: contentType,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    section: section,
                    selectedFilter: selectedFilter,
                    parentContentType: parentContentType,
                    parentContentId: parentContentId
                }
            }
        }).fire();
    };
module.exports["fireContentMenuItemClickedAnalytics"] = $aac5b14b108aa083$export$744f6d2ef9fc49d7;

});

parcelRegister("eLFsG", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gSytF = parcelRequire("gSytF");


var $1IQhI = parcelRequire("1IQhI");

function $db09a4ff30df6c3f$export$4c74f8426e49d30c() {
    return (0, $dYU3e.query)({
        query: (0, $gSytF.default),
        variables: (0, $1IQhI.starredContentMenuQueryVars),
        fetchPolicy: 'network-only'
    });
}
module.exports["preloadStarredContentMenu"] = $db09a4ff30df6c3f$export$4c74f8426e49d30c;

});

parcelRegister("XO4by", function(module, exports) {

var $d4Pk4 = parcelRequire("d4Pk4");


var $dYU3e = parcelRequire("dYU3e");


var $2fgSf = parcelRequire("2fgSf");


var $WG1VM = parcelRequire("WG1VM");


var $8BHAT = parcelRequire("8BHAT");

function $f64f22d885b98eec$export$603721ee0464e7fd(cloudId) {
    return ((0, $2fgSf.shouldUseAGGActivityV3)() ? (0, $dYU3e.queryAgg) : (0, $dYU3e.query))({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $8BHAT.RecentContentMenuQuery),
        variables: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $WG1VM.PAGE_SIZE),
            eventTypes: [],
            objectTypes: (0, $WG1VM.OBJECT_TYPES)
        },
        fetchPolicy: 'network-only'
    });
}
module.exports["preloadRecentContentMenu"] = $f64f22d885b98eec$export$603721ee0464e7fd;

});

parcelRegister("1NFFE", function(module, exports) {

let $14fab102d8335da7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14fab102d8335da7$var$load("Wowvf"),
    $14fab102d8335da7$var$load("2yM8Y")
]).then(()=>parcelRequire('kIWbA'));

});

parcelRegister("3v0xY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

const $b3ea6dd191ed3e50$export$7613f0bd7ffe380c = (icon, label, fallbackUrl, options)=>{
    const { labelElem: labelElem, apsKey: apsKey, ref: ref, analyticsName: analyticsName, menuItemId: menuItemId } = options ?? {};
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useMemo)(()=>({
            type: 'link',
            icon: icon,
            label: formatMessage(label),
            labelElem: labelElem,
            apsKey: apsKey,
            fallbackUrl: fallbackUrl,
            ref: ref,
            analyticsName: analyticsName,
            ...menuItemId ? {
                menuItemId: menuItemId
            } : {}
        }), [
        apsKey,
        fallbackUrl,
        formatMessage,
        icon,
        label,
        labelElem,
        ref,
        analyticsName,
        menuItemId
    ]);
};
module.exports["useAppGlobalShortcutLinkItem"] = $b3ea6dd191ed3e50$export$7613f0bd7ffe380c;

});

parcelRegister("1mG05", function(module, exports) {
const $0968601a95585f25$export$f817d2300729b821 = [
    'jira',
    'confluence'
];
const $0968601a95585f25$export$180016b363be5dc = [
    'confluence',
    'jira',
    'home'
];
const $0968601a95585f25$export$cebe16b091a89fcc = [
    'JIRA_SOFTWARE',
    'CONFLUENCE'
];
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS"] = $0968601a95585f25$export$f817d2300729b821;
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS"] = $0968601a95585f25$export$180016b363be5dc;
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS"] = $0968601a95585f25$export$cebe16b091a89fcc;

});

parcelRegister("5V1fS", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");


var $9wGTI = parcelRequire("9wGTI");

const $ae7788d51c7989c6$var$getEmoji = (content)=>{
    const emojiPropertyPublished = (0, $8rneB.getEmojiPublishedFromProperties)(content);
    const emojiPropertyDraft = (0, $8rneB.getEmojiDraftFromProperties)(content);
    const emoji = emojiPropertyPublished || emojiPropertyDraft || (0, $brn6e.getEmojiFromTitle)(content.title);
    return {
        hasEmojiProperty: Boolean(emojiPropertyPublished || emojiPropertyDraft),
        emoji: emoji
    };
};
const $ae7788d51c7989c6$var$isEmojiSupportedType = (type)=>!!type && (type !== 'whiteboard' || (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles'));
const $ae7788d51c7989c6$var$getTitle = (title, hasEmojiProperty)=>hasEmojiProperty ? title : (0, $brn6e.removeEmojiFromTitle)(title);
const $ae7788d51c7989c6$export$1d1036e75f38035e = (content)=>{
    if ($ae7788d51c7989c6$var$isEmojiSupportedType(content.type)) {
        const { emoji: emoji, hasEmojiProperty: hasEmojiProperty } = $ae7788d51c7989c6$var$getEmoji(content);
        return {
            emoji: emoji,
            title: $ae7788d51c7989c6$var$getTitle(content.title, hasEmojiProperty)
        };
    }
    return {
        emoji: undefined,
        title: content.title
    };
};
const $ae7788d51c7989c6$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    untitled: {
        id: "side-navigation.content-menu.untitled",
        defaultMessage: "Untitled"
    }
});
module.exports["getContentEmojiAndTitle"] = $ae7788d51c7989c6$export$1d1036e75f38035e;
module.exports["i18n"] = $ae7788d51c7989c6$export$a7357cdd1f0b0168;

});

parcelRegister("26Pni", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $abN8T = parcelRequire("abN8T");


var $6a9Hv = parcelRequire("6a9Hv");


var $9wEpK = parcelRequire("9wEpK");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $1YXTQ = parcelRequire("1YXTQ");


var $bCECL = parcelRequire("bCECL");


var $eFm27 = parcelRequire("eFm27");


var $jlIaF = parcelRequire("jlIaF");


var $1IQhI = parcelRequire("1IQhI");


var $6y3LW = parcelRequire("6y3LW");


var $5V1fS = parcelRequire("5V1fS");

const $17ab53893dbb998b$export$9a473b3d087f0f67 = (params)=>{
    const $ = (0, $frIzR.c)(12);
    const intl = (0, $8C5kA.default)();
    let t0;
    if ($[0] !== params.searchText) {
        t0 = {
            searchText: params.searchText
        };
        $[0] = params.searchText;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading, error: error, filteredNodes: filteredNodes, hasNextPage: hasNextPage, loadMore: loadMore } = $17ab53893dbb998b$export$e3e9588fd2c1abdd(t0);
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[2] = t2;
            } else t2 = $[2];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[3] !== filteredNodes || $[4] !== intl) {
            const items = [];
            for (const node of filteredNodes){
                if (!node) continue;
                const { emoji: emoji, title: title } = (0, $5V1fS.getContentEmojiAndTitle)(node);
                items.push({
                    elemBefore: node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                        type: node.type,
                        subType: node.subType,
                        emoji: emoji
                    }) : null,
                    elemAfter: node.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17ab53893dbb998b$var$StarButton, {
                        contentId: node.id,
                        contentType: node.type,
                        isStarred: node.metadata?.currentuser?.favourited?.isFavourite || false
                    }) : undefined,
                    primaryLabel: title || intl.formatMessage((0, $5V1fS.i18n).untitled),
                    secondaryLabel: node.space?.name || "",
                    tertiaryLabel: node.metadata?.currentuser?.favourited?.favouritedDate ? (0, $1YXTQ.formatTimeAgo)(intl, node.metadata.currentuser.favourited.favouritedDate) : undefined,
                    href: `${(0, $jlIaF.CONTEXT_PATH)}${node.links?.webui || ""}`
                });
            }
            t2 = items.length > 0 ? [
                {
                    header: "",
                    items: items
                }
            ] : [];
            $[3] = filteredNodes;
            $[4] = intl;
            $[5] = t2;
        } else t2 = $[5];
        t1 = t2;
    }
    const sections = t1;
    const t2 = loading && !data;
    const t3 = error || undefined;
    let t4;
    if ($[6] !== hasNextPage || $[7] !== loadMore || $[8] !== sections || $[9] !== t2 || $[10] !== t3) {
        t4 = {
            sections: sections,
            hasMore: hasNextPage,
            isLoading: t2,
            loadMore: loadMore,
            error: t3
        };
        $[6] = hasNextPage;
        $[7] = loadMore;
        $[8] = sections;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};
const $17ab53893dbb998b$export$e3e9588fd2c1abdd = (params)=>{
    const $ = (0, $frIzR.c)(17);
    const searchText = params.searchText || "";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            variables: (0, $1IQhI.starredContentMenuQueryVars),
            fetchPolicy: "cache-and-network"
        };
        $[0] = t0;
    } else t0 = $[0];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, networkStatus: networkStatus } = (0, $jMyy4.useQueryInterop)((0, $1IQhI.StarredContentMenuQuery), t0);
    const hasNextPage = data?.favoriteContent?.pageInfo?.hasNextPage || false;
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[1] = t2;
            } else t2 = $[1];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[2] !== data?.favoriteContent?.nodes || $[3] !== searchText) {
            const lowerFilterText = searchText.toLowerCase();
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(data?.favoriteContent?.nodes?.filter((content)=>content !== null && content !== undefined && (!searchText || (content.title?.toLowerCase() || "").includes(lowerFilterText))), $17ab53893dbb998b$var$_temp) ?? [];
            $[2] = data?.favoriteContent?.nodes;
            $[3] = searchText;
            $[4] = t2;
        } else t2 = $[4];
        t1 = t2;
    }
    const filteredNodes = t1;
    let t2;
    if ($[5] !== data?.favoriteContent?.nodes?.length || $[6] !== fetchMore || $[7] !== hasNextPage || $[8] !== networkStatus) {
        t2 = ()=>{
            if (networkStatus === (0, $9wEpK.NetworkStatus).ready && hasNextPage) $17ab53893dbb998b$export$102f63446941fd83(fetchMore, data?.favoriteContent?.nodes?.length || 0);
        };
        $[5] = data?.favoriteContent?.nodes?.length;
        $[6] = fetchMore;
        $[7] = hasNextPage;
        $[8] = networkStatus;
        $[9] = t2;
    } else t2 = $[9];
    data?.favoriteContent?.nodes;
    const loadMore = t2;
    let t3;
    if ($[10] !== data || $[11] !== error || $[12] !== filteredNodes || $[13] !== hasNextPage || $[14] !== loadMore || $[15] !== loading) {
        t3 = {
            data: data,
            loading: loading,
            error: error,
            filteredNodes: filteredNodes,
            hasNextPage: hasNextPage,
            loadMore: loadMore
        };
        $[10] = data;
        $[11] = error;
        $[12] = filteredNodes;
        $[13] = hasNextPage;
        $[14] = loadMore;
        $[15] = loading;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
};
const $17ab53893dbb998b$export$102f63446941fd83 = (fetchMore, start)=>{
    fetchMore({
        variables: {
            start: start
        },
        updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
            if (!fetchMoreResult) return prev;
            const prevEdges = prev.favoriteContent?.nodes || [];
            const fetchMoreEdges = fetchMoreResult.favoriteContent?.nodes || [];
            const mergedEdges = [
                ...prevEdges,
                ...fetchMoreEdges
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'favoriteContent.nodes', mergedEdges);
            return result;
        }
    });
};
const $17ab53893dbb998b$var$StarButton = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { contentId: contentId, contentType: contentType, isStarred: isStarred } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== createAnalyticsEvent) {
        t1 = ()=>{
            (0, $6y3LW.fireContentMenuItemClickedAnalytics)(createAnalyticsEvent, "starredNavigationMenuItem", {
                componentType: "customItemAction",
                itemId: "star",
                parentContentType: contentType,
                parentContentId: contentId
            })();
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const onStar = t1;
    let t2;
    if ($[4] !== contentId || $[5] !== contentType || $[6] !== createAnalyticsEvent) {
        t2 = ()=>{
            (0, $6y3LW.fireContentMenuItemClickedAnalytics)(createAnalyticsEvent, "starredNavigationMenuItem", {
                componentType: "customItemAction",
                itemId: "unstar",
                parentContentType: contentType,
                parentContentId: contentId
            })();
        };
        $[4] = contentId;
        $[5] = contentType;
        $[6] = createAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    const onUnstar = t2;
    let t3;
    if ($[8] !== contentId || $[9] !== isStarred || $[10] !== onStar || $[11] !== onUnstar) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eFm27.PageStarButton), {
            contentId: contentId,
            isStarred: isStarred,
            size: "small",
            tooltipPosition: "top",
            onStar: onStar,
            onUnstar: onUnstar,
            spacing: "none"
        });
        $[8] = contentId;
        $[9] = isStarred;
        $[10] = onStar;
        $[11] = onUnstar;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};
function $17ab53893dbb998b$var$_temp(content_0) {
    return content_0?.id;
}
module.exports["useStarredItems"] = $17ab53893dbb998b$export$9a473b3d087f0f67;
module.exports["useStarredData"] = $17ab53893dbb998b$export$e3e9588fd2c1abdd;
module.exports["fetchMoreStarredContent"] = $17ab53893dbb998b$export$102f63446941fd83;

});

parcelRegister("gSytF", function(module, exports) {
/**
 * @generated SignedSource<<c3487394d0e64b7f098c1e605be3986c>>
 * @relayHash 0913aa0e7f577fc63dfd041de0b5136e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468
const $5baefebdfa73b4d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "favoriteContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContributionStatusSummary",
                                            "kind": "LinkedField",
                                            "name": "lastcontributed",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "when"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                },
                {
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "0913aa0e7f577fc63dfd041de0b5136e",
            "id": "ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468",
            "metadata": {},
            "name": "StarredContentMenuQuery",
            "operationKind": "query",
            "text": "query StarredContentMenuQuery($limit:Int=30,$start:Int!){favoriteContent(limit:$limit,start:$start){nodes{id,type,subType,title,status,space{id,name},links{webui,editui},metadata{currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}},pageInfo{hasNextPage},edges{cursor}}}"
        }
    };
}();
$5baefebdfa73b4d2$var$node.hash = "d919f41ac18e2cfc51a95f7043552fc1";
var $5baefebdfa73b4d2$export$2e2bcd8739ae039 = $5baefebdfa73b4d2$var$node;
module.exports["default"] = $5baefebdfa73b4d2$export$2e2bcd8739ae039;

});

parcelRegister("8BHAT", function(module, exports) {
/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");

const $87679b46728de696$export$a62e7697f515af4e = (0, $eSUdr.default)`query RecentContentMenuQuery($cloudId:ID!$first:Int$after:String$eventTypes:[String!]$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes eventTypes:$eventTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}...on ConfluenceDatabase{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}...on ConfluenceEmbed{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceInlineComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}}}...on ConfluenceFooterComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}}}}}event{id timestamp eventType}}}pageInfo{hasNextPage endCursor}}}}}`;
module.exports["RecentContentMenuQuery"] = $87679b46728de696$export$a62e7697f515af4e;

});


//# sourceMappingURL=GlobalNavigationComponent.e1aeb9c2.js.map
